import type { Variants } from '../types';

const metaDescriptionVariantTitles: Record<string, Variants> = {
	'/fr/serie/fallout/saison-2': 'V1',
	'/fr/serie/hijack/saison-2': 'V2',
	'/fr/serie/cross/saison-2': 'V3',
	'/fr/serie/56-days/saison-1': 'V1',
	'/fr/serie/day-one/saison-1': 'V2',
	'/fr/serie/esa-noche/saison-1': 'V3',
	'/fr/serie/falling-skies/saison-1': 'V1',
	'/fr/serie/crap-happens/saison-1': 'V2',
	'/fr/serie/fallout/saison-1': 'V3',
	'/fr/serie/hells-paradise/saison-2': 'V1',
	'/fr/serie/a-friend-a-murderer/saison-1': 'V2',
	'/fr/serie/game-of-thrones/saison-1': 'V3',
	'/fr/serie/dynasty-the-murdochs/saison-1': 'V1',
	'/fr/serie/agents-du-mystere/saison-2': 'V2',
	'/fr/serie/cross/saison-1': 'V3',
	'/fr/serie/age-of-attraction/saison-1': 'V1',
	'/fr/serie/blue-therapy/saison-1': 'V2',
	'/fr/serie/comme-tu-brilles/saison-1': 'V3',
	'/fr/serie/hijack/saison-1': 'V1',
	'/fr/serie/darwins-incident/saison-1': 'V2',
	'/fr/serie/from/saison-1': 'V3',
	'/fr/serie/beastars/saison-3': 'V1',
	'/fr/serie/euphoria/saison-1': 'V2',
	'/fr/serie/beast-games/saison-2': 'V3',
	'/fr/serie/how-to-get-to-heaven-from-belfast/saison-1': 'V1',
	'/fr/serie/high-potential/saison-1': 'V2',
	'/fr/serie/imperfect-women/saison-1': 'V3',
	'/fr/serie/furies-0/saison-2': 'V1',
	'/fr/serie/chicago-fire/saison-14': 'V2',
	'/fr/serie/house-of-the-dragon/saison-2': 'V3',
	'/fr/serie/falling-skies/saison-5': 'V1',
	'/fr/serie/el-asesino-de-tiktok/saison-1': 'V2',
	'/fr/serie/gen-v/saison-2': 'V3',
	'/fr/serie/from/saison-3': 'V1',
	'/fr/serie/boyfriend-on-demand/saison-1': 'V2',
	'/fr/serie/fire-country/saison-4': 'V3',
	'/fr/serie/good-doctor-2017/saison-7': 'V1',
	'/fr/serie/1923/saison-2': 'V2',
	'/fr/serie/from/saison-2': 'V3',
	'/fr/serie/grimm/saison-1': 'V1',
	'/fr/serie/animal-kingdom/saison-1': 'V2',
	'/fr/serie/foundation/saison-3': 'V3',
	'/fr/serie/fargo/saison-1': 'V1',
	'/fr/serie/emily-in-paris/saison-5': 'V2',
	'/fr/serie/frieren/saison-1': 'V3',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-16': 'V1',
	'/fr/serie/for-all-mankind/saison-1': 'V2',
	'/fr/serie/daredevil-born-again/saison-1': 'V3',
	'/fr/serie/enen-no-shouboutai-fire-force/saison-3': 'V1',
	'/fr/serie/attack-on-titan/saison-1': 'V2',
	'/fr/serie/fatal-seduction/saison-3': 'V3',
	'/fr/serie/euphoria/saison-2': 'V1',
	'/fr/serie/amicalement-votre/saison-1': 'V2',
	'/fr/serie/homicide/saison-2': 'V3',
	'/fr/serie/andor/saison-1': 'V1',
	'/fr/serie/below-deck-down-under/saison-4': 'V2',
	'/fr/serie/dune-the-sisterhood/saison-1': 'V3',
	'/fr/serie/fargo/saison-5': 'V1',
	'/fr/serie/black-mirror/saison-7': 'V2',
	'/fr/serie/ghosts/saison-1': 'V3',
	'/fr/serie/breaking-bad/saison-5': 'V1',
	'/fr/serie/friends/saison-1': 'V2',
	'/fr/serie/attack-on-titan/saison-4': 'V3',
	'/fr/serie/dexter/saison-1': 'V1',
	'/fr/serie/dare-you-to-death/saison-1': 'V2',
	'/fr/serie/falling-skies/saison-2': 'V3',
	'/fr/serie/demon-slayer-kimetsu-no-yaiba/saison-1': 'V1',
	'/fr/serie/dark-moon-the-blood-altar/saison-1': 'V2',
	'/fr/serie/greys-anatomy/saison-21': 'V3',
	'/fr/serie/dark-winds/saison-3': 'V1',
	'/fr/serie/game-of-thrones/saison-2': 'V2',
	'/fr/serie/fringe/saison-1': 'V3',
	'/fr/serie/fargo/saison-4': 'V1',
	'/fr/serie/department-q/saison-1': 'V2',
	'/fr/serie/fargo/saison-2': 'V3',
	'/fr/serie/demon-slayer-kimetsu-no-yaiba/saison-5': 'V1',
	'/fr/serie/batman-la-serie-animee/saison-1': 'V2',
	'/fr/serie/chicago-fire/saison-13': 'V3',
	'/fr/serie/dark-winds/saison-2': 'V1',
	'/fr/serie/doctor-who-2023/saison-2': 'V2',
	'/fr/serie/alice-in-borderland/saison-3': 'V3',
	'/fr/serie/homeland/saison-1': 'V1',
	'/fr/serie/breaking-bad/saison-2': 'V2',
	'/fr/serie/falling-skies/saison-3': 'V3',
	'/fr/serie/game-of-thrones/saison-8': 'V1',
	'/fr/serie/chernobyl/saison-1': 'V2',
	'/fr/serie/ghosts/saison-2': 'V3',
	'/fr/serie/greys-anatomy/saison-1': 'V1',
	'/fr/serie/good-doctor-2017/saison-6': 'V2',
	'/fr/serie/for-all-mankind/saison-4': 'V3',
	'/fr/serie/doctor-who/saison-1': 'V1',
	'/fr/serie/dragon-ball-super/saison-1': 'V2',
	'/fr/serie/game-of-thrones/saison-4': 'V3',
	'/fr/serie/fargo/saison-3': 'V1',
	'/fr/serie/babylon-5/saison-1': 'V2',
	'/fr/serie/animal-kingdom/saison-3': 'V3',
	'/fr/serie/hells-paradise/saison-1': 'V1',
	'/fr/serie/adolescence-2025/saison-1': 'V2',
	'/fr/serie/drommeren/saison-1': 'V3',
	'/fr/serie/falling-skies/saison-4': 'V1',
	'/fr/serie/evil/saison-1': 'V2',
	'/fr/serie/game-of-thrones/saison-3': 'V3',
	'/fr/serie/death-note/saison-1': 'V1',
	'/fr/serie/breaking-bad/saison-3': 'V2',
	'/fr/serie/detective-conan/saison-1': 'V3',
	'/fr/serie/black-clover/saison-1': 'V1',
	'/fr/serie/demon-slayer-kimetsu-no-yaiba/saison-4': 'V2',
	'/fr/serie/1883/saison-1': 'V3',
	'/fr/serie/charlottes-web/saison-1': 'V1',
	'/fr/serie/dexter-new-blood/saison-1': 'V2',
	'/fr/serie/breaking-bad/saison-4': 'V3',
	'/fr/serie/a-man-on-the-inside/saison-2': 'V1',
	'/fr/serie/absentia/saison-1': 'V2',
	'/fr/serie/chicago-fire/saison-12': 'V3',
	'/fr/serie/bones/saison-1': 'V1',
	'/fr/serie/en-el-barro/saison-1': 'V2',
	'/fr/serie/in-the-clear-moonlit-dusk/saison-1': 'V3',
	'/fr/serie/attack-on-titan/saison-3': 'V1',
	'/fr/serie/black-mirror/saison-1': 'V2',
	'/fr/serie/dexter/saison-3': 'V3',
	'/fr/serie/boku-no-hero-academia/saison-8': 'V1',
	'/fr/serie/dexter/saison-2': 'V2',
	'/fr/serie/grace/saison-5': 'V3',
	'/fr/serie/game-of-thrones/saison-6': 'V1',
	'/fr/serie/good-doctor-2017/saison-4': 'V2',
	'/fr/serie/fringe/saison-2': 'V3',
	'/fr/serie/for-all-mankind/saison-3': 'V1',
	'/fr/serie/hunter-x-hunter-2011-2011/saison-1': 'V2',
	'/fr/serie/1-rue-sesame/saison-2': 'V3',
	'/fr/serie/anderson-spider-silva/saison-1': 'V1',
	'/fr/serie/battlestar-galactica/saison-1': 'V2',
	'/fr/serie/hacks/saison-4': 'V3',
	'/fr/serie/a-thousand-blows/saison-1': 'V1',
	'/fr/serie/a-man-on-the-inside/saison-1': 'V2',
	'/fr/serie/foundation/saison-2': 'V3',
	'/fr/serie/finding-her-edge/saison-1': 'V1',
	'/fr/serie/blacklist/saison-1': 'V2',
	'/fr/serie/better-call-saul/saison-1': 'V3',
	'/fr/serie/banshee/saison-1': 'V1',
	'/fr/serie/animal-kingdom/saison-6': 'V2',
	'/fr/serie/animal-kingdom/saison-5': 'V3',
	'/fr/serie/dark/saison-2': 'V1',
	'/fr/serie/esprits-criminels/saison-1': 'V2',
	'/fr/serie/good-sports-with-kevin-hart-and-kenan-thompson/saison-1': 'V3',
	'/fr/serie/game-of-thrones/saison-5': 'V1',
	'/fr/serie/fire-country/saison-3': 'V2',
	'/fr/serie/freres-darmes/saison-1': 'V3',
	'/fr/serie/house/saison-5': 'V1',
	'/fr/serie/can-you-translate-this-love/saison-1': 'V2',
	'/fr/serie/dark/saison-3': 'V3',
	'/fr/serie/foundation/saison-1': 'V1',
	'/fr/serie/better-call-saul/saison-2': 'V2',
	'/fr/serie/black-rabbit/saison-1': 'V3',
	'/fr/serie/house-of-david/saison-1': 'V1',
	'/fr/serie/house-of-guinness/saison-1': 'V2',
	'/fr/serie/arcane/saison-1': 'V3',
	'/fr/serie/columbo/saison-1': 'V1',
	'/fr/serie/good-doctor-2017/saison-2': 'V2',
	'/fr/serie/good-doctor-2017/saison-5': 'V3',
	'/fr/serie/chief-of-war/saison-1': 'V1',
	'/fr/serie/el-deshielo/saison-3': 'V2',
	'/fr/serie/chicago-fire/saison-1': 'V3',
	'/fr/serie/community/saison-1': 'V1',
	'/fr/serie/chicago-p-d/saison-11': 'V2',
	'/fr/serie/bridgerton-young-queen-charlotte-spinoff/saison-1': 'V3',
	'/fr/serie/arrested-development/saison-1': 'V1',
	'/fr/serie/american-horror-story/saison-12': 'V2',
	'/fr/serie/better-call-saul/saison-6': 'V3',
	'/fr/serie/black-sails/saison-1': 'V1',
	'/fr/serie/demon-slayer-kimetsu-no-yaiba/saison-3': 'V2',
	'/fr/serie/brooklyn-nine-nine/saison-7': 'V3',
	'/fr/serie/gen-v/saison-1': 'V1',
	'/fr/serie/elementary/saison-1': 'V2',
	'/fr/serie/attack-on-titan/saison-2': 'V3',
	'/fr/serie/fleabag/saison-1': 'V1',
	'/fr/serie/better-call-saul/saison-4': 'V2',
	'/fr/serie/better-call-saul/saison-3': 'V3',
	'/fr/serie/dexter/saison-8': 'V1',
	'/fr/serie/avatar-le-dernier-maitre-de-lair/saison-1': 'V2',
	'/fr/serie/hell-mode-the-hardcore-gamer-dominates-in-another-world-with-garbage-balancing/saison-1': 'V3',
	'/fr/serie/brooklyn-nine-nine/saison-1': 'V1',
	'/fr/serie/formule-1-pilotes-de-leur-destin/saison-6': 'V2',
	'/fr/serie/dawson/saison-1': 'V3',
	'/fr/serie/black-bird/saison-1': 'V1',
	'/fr/serie/demon-slave/saison-2': 'V2',
	'/fr/serie/dead-account/saison-1': 'V3',
	'/fr/serie/canada-shore/saison-1': 'V1',
	'/fr/serie/bones/saison-2': 'V2',
	'/fr/serie/garcia/saison-1': 'V3',
	'/fr/serie/astrid-et-raphaelle/saison-6': 'V1',
	'/fr/serie/black-mirror/saison-3': 'V2',
	'/fr/serie/black-mirror/saison-6': 'V3',
	'/fr/serie/alice-in-borderland/saison-1': 'V1',
	'/fr/serie/arrow/saison-1': 'V2',
	'/fr/serie/dexter/saison-7': 'V3',
	'/fr/serie/dexter/saison-4': 'V1',
	'/fr/serie/ballard/saison-1': 'V2',
	'/fr/serie/hightown/saison-1': 'V3',
	'/fr/serie/hannibal/saison-1': 'V1',
	'/fr/serie/and-just-like-that/saison-3': 'V2',
	'/fr/serie/high-school-kimengumi/saison-1': 'V3',
	'/fr/serie/elsbeth/saison-2': 'V1',
	'/fr/serie/everwood/saison-1': 'V2',
	'/fr/serie/dexter/saison-6': 'V3',
	'/fr/serie/hidden-love/saison-1': 'V1',
	'/fr/serie/dark-matter-2024/saison-1': 'V2',
	'/fr/serie/black-mirror/saison-2': 'V3',
	'/fr/serie/absentia/saison-2': 'V1',
	'/fr/serie/friday-night-lights/saison-1': 'V2',
	'/fr/serie/boruto-naruto-next-generations/saison-1': 'V3',
	'/fr/serie/fate-strange-fake/saison-1': 'V1',
	'/fr/serie/friends/saison-2': 'V2',
	'/fr/serie/anne-rices-mayfair-witches/saison-1': 'V3',
	'/fr/serie/better-call-saul/saison-5': 'V1',
	'/fr/serie/dead-like-me/saison-1': 'V2',
	'/fr/serie/derry-girls/saison-1': 'V3',
	'/fr/serie/american-horror-story/saison-1': 'V1',
	'/fr/serie/chicago-fire/saison-11': 'V2',
	'/fr/serie/boku-no-hero-academia/saison-3': 'V3',
	'/fr/serie/beast-games/saison-1': 'V1',
	'/fr/serie/godfather-of-harlem/saison-1': 'V2',
	'/fr/serie/a-discovery-of-witches/saison-1': 'V3',
	'/fr/serie/homeland/saison-3': 'V1',
	'/fr/serie/hercule-poirot/saison-1': 'V2',
	'/fr/serie/deadloch/saison-1': 'V3',
	'/fr/serie/hazbin-hotel/saison-2': 'V1',
	'/fr/serie/demon-slayer-kimetsu-no-yaiba/saison-2': 'V2',
	'/fr/serie/farzi/saison-1': 'V3',
	'/fr/serie/chicago-med/saison-9': 'V1',
	'/fr/serie/b-r-i/saison-2': 'V2',
	'/fr/serie/evil/saison-2': 'V3',
	'/fr/serie/blue-lights/saison-2': 'V1',
	'/fr/serie/dexter/saison-5': 'V2',
	'/fr/serie/fbi-2018/saison-1': 'V3',
	'/fr/serie/common-side-effects/saison-1': 'V1',
	'/fr/serie/hacks/saison-1': 'V2',
	'/fr/serie/black-mirror/saison-4': 'V3',
	'/fr/serie/ben-10/saison-1': 'V1',
	'/fr/serie/house/saison-2': 'V2',
	'/fr/serie/demon-slave/saison-1': 'V3',
	'/fr/serie/flash/saison-1': 'V1',
	'/fr/serie/formule-1-pilotes-de-leur-destin/saison-4': 'V2',
	'/fr/serie/farming-life-in-another-world-2023/saison-1': 'V3',
	'/fr/serie/easygoing-territory-defense-by-the-optimistic-lord/saison-1': 'V1',
	'/fr/serie/fbi-most-wanted/saison-2': 'V2',
	'/fr/serie/boku-no-hero-academia/saison-1': 'V3',
	'/fr/serie/down-cemetery-road/saison-1': 'V1',
	'/fr/serie/doctor-who/saison-2': 'V2',
	'/fr/serie/his-dark-materials-a-la-croisee-des-mondes/saison-1': 'V3',
	'/fr/serie/gotham/saison-1': 'V1',
	'/fr/serie/formule-1-pilotes-de-leur-destin/saison-5': 'V2',
	'/fr/serie/esprits-criminels/saison-17': 'V3',
	'/fr/serie/grimm/saison-6': 'V1',
	'/fr/serie/ginny-and-georgia/saison-3': 'V2',
	'/fr/serie/billions/saison-1': 'V3',
	'/fr/serie/animal-salvaje/saison-1': 'V1',
	'/fr/serie/fear-the-walking-dead/saison-1': 'V2',
	'/fr/serie/dae-jang-geum/saison-1': 'V3',
	'/fr/serie/air-disasters/saison-4': 'V1',
	'/fr/serie/9-1-1/saison-2': 'V2',
	'/fr/serie/final-siren-inside-the-afl/saison-1': 'V3',
	'/fr/serie/heroes/saison-1': 'V1',
	'/fr/serie/9-1-1/saison-7': 'V2',
	'/fr/serie/american-gods/saison-1': 'V3',
	'/fr/serie/boardwalk-empire/saison-1': 'V1',
	'/fr/serie/an-adventurers-daily-grind-at-age-29/saison-1': 'V2',
	'/fr/serie/future-man/saison-1': 'V3',
	'/fr/serie/c-b-strike-2017/saison-1': 'V1',
	'/fr/serie/house/saison-7': 'V2',
	'/fr/serie/all-the-queens-men/saison-4': 'V3',
	'/fr/serie/grimm/saison-4': 'V1',
	'/fr/serie/greys-anatomy/saison-4': 'V2',
	'/fr/serie/elsbeth/saison-1': 'V3',
	'/fr/serie/family-guy/saison-1': 'V1',
	'/fr/serie/conversations-with-friends/saison-1': 'V2',
	'/fr/serie/hpi/saison-1': 'V3',
	'/fr/serie/boku-no-hero-academia/saison-7': 'V1',
	'/fr/serie/fire-country/saison-2': 'V2',
	'/fr/serie/camelot/saison-1': 'V3',
	'/fr/serie/dr-stone/saison-4': 'V1',
	'/fr/serie/adventure-time/saison-1': 'V2',
	'/fr/serie/greys-anatomy/saison-2': 'V3',
	'/fr/serie/esprits-criminels/saison-2': 'V1',
	'/fr/serie/formule-1-pilotes-de-leur-destin/saison-3': 'V2',
	'/fr/serie/countdown-2025/saison-1': 'V3',
	'/fr/serie/homeland/saison-8': 'V1',
	'/fr/serie/clarksons-farm/saison-4': 'V2',
	'/fr/serie/bob-leponge-lile-karate/saison-1': 'V3',
	'/fr/serie/dragon-ball-z-kai/saison-1': 'V1',
	'/fr/serie/barry/saison-1': 'V2',
	'/fr/serie/american-horror-story/saison-2': 'V3',
	'/fr/serie/gnosia/saison-1': 'V1',
	'/fr/serie/chicago-p-d/saison-1': 'V2',
	'/fr/serie/charmed/saison-1': 'V3',
	'/fr/serie/fbi-2018/saison-5': 'V1',
	'/fr/serie/harry-wild/saison-4': 'V2',
	'/fr/serie/anne-rices-mayfair-witches/saison-2': 'V3',
	'/fr/serie/grotesquerie/saison-1': 'V1',
	'/fr/serie/house/saison-4': 'V2',
	'/fr/serie/chicago-med/saison-3': 'V3',
	'/fr/serie/a-teacher/saison-1': 'V1',
	'/fr/serie/fire-country/saison-1': 'V2',
	'/fr/serie/fringe/saison-4': 'V3',
	'/fr/serie/gomorrah/saison-1': 'V1',
	'/fr/serie/bosch/saison-1': 'V2',
	'/fr/serie/brooklyn-nine-nine/saison-8': 'V3',
	'/fr/serie/c-b-strike-2017/saison-6': 'V1',
	'/fr/serie/between-lands/saison-1': 'V2',
	'/fr/serie/american-gods/saison-3': 'V3',
	'/fr/serie/house/saison-8': 'V1',
	'/fr/serie/alex-hugo/saison-1': 'V2',
	'/fr/serie/homeland/saison-4': 'V3',
	'/fr/serie/greys-anatomy/saison-6': 'V1',
	'/fr/serie/agatha-house-of-harkness/saison-1': 'V2',
	'/fr/serie/all-creatures-great-and-small/saison-4': 'V3',
	'/fr/serie/broadchurch/saison-1': 'V1',
	'/fr/serie/brooklyn-nine-nine/saison-5': 'V2',
	'/fr/serie/greys-anatomy/saison-11': 'V3',
	'/fr/serie/alex-rider/saison-3': 'V1',
	'/fr/serie/blue-exorcist/saison-1': 'V2',
	'/fr/serie/2-broke-girls/saison-6': 'V3',
	'/fr/serie/haikyu/saison-1': 'V1',
	'/fr/serie/doctor-who/saison-5': 'V2',
	'/fr/serie/greys-anatomy/saison-5': 'V3',
	'/fr/serie/feride-vs-the-world/saison-1': 'V1',
	'/fr/serie/blanca/saison-1': 'V2',
	'/fr/serie/24/saison-1': 'V3',
	'/fr/serie/american-horror-story/saison-3': 'V1',
	'/fr/serie/greys-anatomy/saison-12': 'V2',
	'/fr/serie/bones/saison-6': 'V3',
	'/fr/serie/berserk/saison-1': 'V1',
	'/fr/serie/greys-anatomy/saison-3': 'V2',
	'/fr/serie/a-very-royal-scandal/saison-1': 'V3',
	'/fr/serie/blindspot/saison-2': 'V1',
	'/fr/serie/dahmer-monstre-lhistoire-de-jeffrey-dahmer/saison-1': 'V2',
	'/fr/serie/alien-theory/saison-1': 'V3',
	'/fr/serie/homeland/saison-5': 'V1',
	'/fr/serie/banshee/saison-2': 'V2',
	'/fr/serie/dating-naked-draguer-nu/saison-1': 'V3',
	'/fr/serie/blindspot/saison-1': 'V1',
	'/fr/serie/alice-in-borderland/saison-2': 'V2',
	'/fr/serie/hannibal/saison-3': 'V3',
	'/fr/serie/domino-day/saison-1': 'V1',
	'/fr/serie/empathie/saison-1': 'V2',
	'/fr/serie/cowboy-bebop/saison-1': 'V3',
	'/fr/serie/all-creatures-great-and-small/saison-3': 'V1',
	'/fr/serie/hajime-no-ippo/saison-1': 'V2',
	'/fr/serie/counterpart/saison-1': 'V3',
	'/fr/serie/dawson/saison-2': 'V1',
	'/fr/serie/bones/saison-3': 'V2',
	'/fr/serie/catastrophes-naturelles-survivre-au-pire/saison-3': 'V3',
	'/fr/serie/all-of-us-are-dead/saison-1': 'V1',
	'/fr/serie/chicago-med/saison-1': 'V2',
	'/fr/serie/big-mouth-2022/saison-1': 'V3',
	'/fr/serie/goliath/saison-1': 'V1',
	'/fr/serie/blue-bloods/saison-13': 'V2',
	'/fr/serie/call-the-midwife/saison-1': 'V3',
	'/fr/serie/bad-sisters/saison-2': 'V1',
	'/fr/serie/emily-in-paris/saison-4': 'V2',
	'/fr/serie/blue-bloods/saison-14': 'V3',
	'/fr/serie/blacklist/saison-6': 'V1',
	'/fr/serie/bones/saison-8': 'V2',
	'/fr/serie/boku-no-hero-academia/saison-2': 'V3',
	'/fr/serie/blacklist/saison-9': 'V1',
	'/fr/serie/adventure-time-fionna-et-cake/saison-2': 'V2',
	'/fr/serie/black-doves/saison-1': 'V3',
	'/fr/serie/friends/saison-3': 'V1',
	'/fr/serie/enen-no-shouboutai-fire-force/saison-1': 'V2',
	'/fr/serie/detectorists/saison-1': 'V3',
	'/fr/serie/doc/saison-1': 'V1',
	'/fr/serie/boku-no-hero-academia/saison-4': 'V2',
	'/fr/serie/altered-carbon/saison-1': 'V3',
	'/fr/serie/dead-like-me/saison-2': 'V1',
	'/fr/serie/chicago-med/saison-2': 'V2',
	'/fr/serie/greys-anatomy/saison-20': 'V3',
	'/fr/serie/homeland/saison-6': 'V1',
	'/fr/serie/doctor-who-2023/saison-1': 'V2',
	'/fr/serie/ahsoka/saison-1': 'V3',
	'/fr/serie/ghost-whisperer/saison-1': 'V1',
	'/fr/serie/de-viaje-con-los-derbez/saison-1': 'V2',
	'/fr/serie/abbott-elementary/saison-3': 'V3',
	'/fr/serie/castle/saison-5': 'V1',
	'/fr/serie/gortimer-gibbons-life-on-normal-street/saison-1': 'V2',
	'/fr/serie/brooklyn-nine-nine/saison-3': 'V3',
	'/fr/serie/grimm/saison-3': 'V1',
	'/fr/serie/cite-des-ombres/saison-1': 'V2',
	'/fr/serie/docteur-foster/saison-1': 'V3',
	'/fr/serie/call-of-the-night/saison-2': 'V1',
	'/fr/serie/american-primeval/saison-1': 'V2',
	'/fr/serie/2-broke-girls/saison-2': 'V3',
	'/fr/serie/castle/saison-1': 'V1',
	'/fr/serie/golden-kamui/saison-5': 'V2',
	'/fr/serie/fleabag/saison-2': 'V3',
	'/fr/serie/happy-valley/saison-1': 'V1',
	'/fr/serie/black-clover/saison-2': 'V2',
	'/fr/serie/bad-sisters/saison-1': 'V3',
	'/fr/serie/angel-flight/saison-1': 'V1',
	'/fr/serie/flash/saison-9': 'V2',
	'/fr/serie/fear-the-walking-dead/saison-8': 'V3',
	'/fr/serie/esprits-criminels/saison-4': 'V1',
	'/fr/serie/homeland/saison-7': 'V2',
	'/fr/serie/dandadan/saison-2': 'V3',
	'/fr/serie/bates-motel/saison-1': 'V1',
	'/fr/serie/cosmos-a-spacetime-odyssey/saison-1': 'V2',
	'/fr/serie/curb-your-enthusiasm/saison-1': 'V3',
	'/fr/serie/dr-stone/saison-3': 'V1',
	'/fr/serie/greys-anatomy/saison-9': 'V2',
	'/fr/serie/africa/saison-1': 'V3',
	'/fr/serie/accused-2023/saison-1': 'V1',
	'/fr/serie/cashero/saison-1': 'V2',
	'/fr/serie/friends/saison-5': 'V3',
	'/fr/serie/downton-abbey/saison-2': 'V1',
	'/fr/serie/good-boy/saison-1': 'V2',
	'/fr/serie/deaths-game/saison-1': 'V3',
	'/fr/serie/american-horror-story/saison-11': 'V1',
	'/fr/serie/buffy-contre-les-vampires/saison-1': 'V2',
	'/fr/serie/bones/saison-9': 'V3',
	'/fr/serie/hacks/saison-2': 'V1',
	'/fr/serie/esprits-criminels/saison-16': 'V2',
	'/fr/serie/harlan-cobens-lazarus/saison-1': 'V3',
	'/fr/serie/billions/saison-2': 'V1',
	'/fr/serie/fellow-travelers/saison-1': 'V2',
	'/fr/serie/avatar-le-dernier-maitre-de-lair/saison-2': 'V3',
	'/fr/serie/grimm/saison-5': 'V1',
	'/fr/serie/blue-bloods/saison-1': 'V2',
	'/fr/serie/gintama/saison-1': 'V3',
	'/fr/serie/bojack-horseman/saison-1': 'V1',
	'/fr/serie/fbi-2018/saison-2': 'V2',
	'/fr/serie/house-of-cards-2013/saison-1': 'V3',
	'/fr/serie/bloodhounds/saison-1': 'V1',
	'/fr/serie/how-i-met-your-mother/saison-9': 'V2',
	'/fr/serie/desperate-housewives/saison-2': 'V3',
	'/fr/serie/blacklist/saison-3': 'V1',
	'/fr/serie/hpi/saison-2': 'V2',
	'/fr/serie/american-horror-story/saison-5': 'V3',
	'/fr/serie/gilmore-girls/saison-2': 'V1',
	'/fr/serie/girl-from-nowhere/saison-1': 'V2',
	'/fr/serie/firebug/saison-1': 'V3',
	'/fr/serie/fbi-most-wanted/saison-4': 'V1',
	'/fr/serie/arrow/saison-4': 'V2',
	'/fr/serie/doctor-who/saison-4': 'V3',
	'/fr/serie/9-1-1/saison-4': 'V1',
	'/fr/serie/emily-in-paris/saison-1': 'V2',
	'/fr/serie/how-i-met-your-mother/saison-4': 'V3',
	'/fr/serie/greys-anatomy/saison-10': 'V1',
	'/fr/serie/dcs-legends-of-tomorrow/saison-1': 'V2',
	'/fr/serie/billionaires-bunker/saison-1': 'V3',
	'/fr/serie/brooklyn-nine-nine/saison-6': 'V1',
	'/fr/serie/ascension/saison-1': 'V2',
	'/fr/serie/genie-make-a-wish/saison-1': 'V3',
	'/fr/serie/castle/saison-6': 'V1',
	'/fr/serie/bosch-legacy/saison-2': 'V2',
	'/fr/serie/bosch-legacy/saison-1': 'V3',
	'/fr/serie/banshee/saison-3': 'V1',
	'/fr/serie/american-crime-story/saison-1': 'V2',
	'/fr/serie/bull-2016/saison-1': 'V3',
	'/fr/serie/genius/saison-1': 'V1',
	'/fr/serie/devs/saison-1': 'V2',
	'/fr/serie/community/saison-2': 'V3',
	'/fr/serie/avatar-the-last-airbender-0/saison-1': 'V1',
	'/fr/serie/chicago-p-d/saison-3': 'V2',
	'/fr/serie/blue-bloods/saison-12': 'V3',
	'/fr/serie/de-lautre-cote/saison-1': 'V1',
	'/fr/serie/castle/saison-7': 'V2',
	'/fr/serie/alone/saison-1': 'V3',
	'/fr/serie/digimon/saison-1': 'V1',
	'/fr/serie/family-guy/saison-22': 'V2',
	'/fr/serie/avatar-le-dernier-maitre-de-lair/saison-3': 'V3',
	'/fr/serie/arifureta/saison-3': 'V1',
	'/fr/serie/gilmore-girls/saison-4': 'V2',
	'/fr/serie/elementary/saison-2': 'V3',
	'/fr/serie/hightown/saison-3': 'V1',
	'/fr/serie/blacklist/saison-4': 'V2',
	'/fr/serie/elite/saison-1': 'V3',
	'/fr/serie/cheers/saison-1': 'V1',
	'/fr/serie/extraordinary/saison-2': 'V2',
	'/fr/serie/gangs-of-london/saison-2': 'V3',
	'/fr/serie/columbo/saison-10': 'V1',
	'/fr/serie/chicago-p-d/saison-2': 'V2',
	'/fr/serie/doragon-boru-daima/saison-1': 'V3',
	'/fr/serie/cobra-kai/saison-1': 'V1',
	'/fr/serie/baki/saison-1': 'V2',
	'/fr/serie/esprits-criminels/saison-5': 'V3',
	'/fr/serie/ginny-and-georgia/saison-1': 'V1',
	'/fr/serie/gyeongiroun-somun/saison-1': 'V2',
	'/fr/serie/hawaii-5-0/saison-1': 'V3',
	'/fr/serie/bones/saison-11': 'V1',
	'/fr/serie/halt-and-catch-fire/saison-1': 'V2',
	'/fr/serie/babylon-berlin/saison-1': 'V3',
	'/fr/serie/downton-abbey/saison-6': 'V1',
	'/fr/serie/avatar-la-legende-de-korra/saison-1': 'V2',
	'/fr/serie/friends/saison-10': 'V3',
	'/fr/serie/after-life/saison-1': 'V1',
	'/fr/serie/family-guy/saison-21': 'V2',
	'/fr/serie/esprits-criminels/saison-3': 'V3',
	'/fr/serie/eojjeoda-balgyeonhan-haru/saison-1': 'V1',
	'/fr/serie/call-the-midwife/saison-6': 'V2',
	'/fr/serie/9-1-1-lone-star/saison-5': 'V3',
	'/fr/serie/how-i-met-your-mother/saison-3': 'V1',
	'/fr/serie/broadchurch/saison-3': 'V2',
	'/fr/serie/all-creatures-great-and-small/saison-2': 'V3',
	'/fr/serie/dickinson/saison-1': 'V1',
	'/fr/serie/fubar/saison-2': 'V2',
	'/fr/serie/dandadan/saison-1': 'V3',
	'/fr/serie/chicago-fire/saison-2': 'V1',
	'/fr/serie/greys-anatomy/saison-15': 'V2',
	'/fr/serie/billions/saison-6': 'V3',
	'/fr/serie/american-horror-story/saison-9': 'V1',
	'/fr/serie/dr-stone/saison-1': 'V2',
	'/fr/serie/derry-girls/saison-3': 'V3',
	'/fr/serie/doctor-who/saison-12': 'V1',
	'/fr/serie/billions/saison-7': 'V2',
	'/fr/serie/berlin-2023/saison-1': 'V3',
	'/fr/serie/borgen-power-and-glory/saison-1': 'V1',
	'/fr/serie/danziyonfan/saison-1': 'V2',
	'/fr/serie/fbi-international/saison-4': 'V3',
	'/fr/serie/hannah-montana/saison-1': 'V1',
	'/fr/serie/gilmore-girls/saison-3': 'V2',
	'/fr/serie/chicago-p-d/saison-6': 'V3',
	'/fr/serie/bodies/saison-1': 'V1',
	'/fr/serie/friends/saison-4': 'V2',
	'/fr/serie/bosch/saison-7': 'V3',
	'/fr/serie/arrow/saison-2': 'V1',
	'/fr/serie/haikyu/saison-2': 'V2',
	'/fr/serie/bluey/saison-1': 'V3',
	'/fr/serie/chicago-p-d/saison-9': 'V1',
	'/fr/serie/downton-abbey/saison-4': 'V2',
	'/fr/serie/gate/saison-1': 'V3',
	'/fr/serie/fear-the-walking-dead/saison-4': 'V1',
	'/fr/serie/chicago-fire/saison-9': 'V2',
	'/fr/serie/chicago-med/saison-4': 'V3',
	'/fr/serie/bojack-horseman/saison-5': 'V1',
	'/fr/serie/a-la-croisee-des-mondes/saison-3': 'V2',
	'/fr/serie/grantchester/saison-2': 'V3',
	'/fr/serie/fbi-2018/saison-3': 'V1',
	'/fr/serie/champignon-witch/saison-1': 'V2',
	'/fr/serie/beauty-and-the-beast/saison-1': 'V3',
	'/fr/serie/dallas-1978/saison-1': 'V1',
	'/fr/serie/arrested-development/saison-2': 'V2',
	'/fr/serie/2-broke-girls/saison-5': 'V3',
	'/fr/serie/and-just-like-that/saison-1': 'V1',
	'/fr/serie/buffy-contre-les-vampires/saison-2': 'V2',
	'/fr/serie/creature-commandos/saison-1': 'V3',
	'/fr/serie/brooklyn-nine-nine/saison-4': 'V1',
	'/fr/serie/grace/saison-4': 'V2',
	'/fr/serie/american-horror-story/saison-8': 'V3',
	'/fr/serie/how-to-make-it-in-america/saison-2': 'V1',
	'/fr/serie/goliath/saison-4': 'V2',
	'/fr/serie/atlanta/saison-1': 'V3',
	'/fr/serie/family-guy/saison-10': 'V1',
	'/fr/serie/his-dark-materials-a-la-croisee-des-mondes/saison-2': 'V2',
	'/fr/serie/goliath/saison-2': 'V3',
	'/fr/serie/arabesque/saison-1': 'V1',
	'/fr/serie/how-i-met-your-mother/saison-6': 'V2',
	'/fr/serie/great-teacher-onizuka/saison-1': 'V3',
	'/fr/serie/chicago-med/saison-5': 'V1',
	'/fr/serie/dororo-2019/saison-1': 'V2',
	'/fr/serie/fear-the-walking-dead/saison-7': 'V3',
	'/fr/serie/das-boot/saison-1': 'V1',
	'/fr/serie/a-discovery-of-witches/saison-3': 'V2',
	'/fr/serie/american-horror-story/saison-10': 'V3',
	'/fr/serie/fawlty-towers/saison-1': 'V1',
	'/fr/serie/elementary/saison-7': 'V2',
	'/fr/serie/flash/saison-4': 'V3',
	'/fr/serie/american-dad/saison-20': 'V1',
	'/fr/serie/dystopia/saison-1': 'V2',
	'/fr/serie/blue-mountain-state/saison-1': 'V3',
	'/fr/serie/buffy-contre-les-vampires/saison-6': 'V1',
	'/fr/serie/i-parry-everything/saison-1': 'V2',
	'/fr/serie/hell-on-wheels/saison-1': 'V3',
	'/fr/serie/as-you-stood-by/saison-1': 'V1',
	'/fr/serie/grace/saison-3': 'V2',
	'/fr/serie/babylon-5/saison-5': 'V3',
	'/fr/serie/ash-vs-evil-dead/saison-1': 'V1',
	'/fr/serie/house-of-cards-2013/saison-6': 'V2',
	'/fr/serie/30-rock/saison-1': 'V3',
	'/fr/serie/goat-girl/saison-1': 'V1',
	'/fr/serie/esprits-criminels/saison-10': 'V2',
	'/fr/serie/daisy-jones-and-the-six/saison-1': 'V3',
	'/fr/serie/c-b-strike-2017/saison-2': 'V1',
	'/fr/serie/beyond-paradise/saison-2': 'V2',
	'/fr/serie/drawn-together/saison-1': 'V3',
	'/fr/serie/californication/saison-1': 'V1',
	'/fr/serie/bobs-burgers/saison-13': 'V2',
	'/fr/serie/chuck/saison-1': 'V3',
	'/fr/serie/esprits-criminels/saison-13': 'V1',
	'/fr/serie/chicago-p-d/saison-7': 'V2',
	'/fr/serie/blacklist/saison-8': 'V3',
	'/fr/serie/13-reasons-why/saison-1': 'V1',
	'/fr/serie/idol-i/saison-1': 'V2',
	'/fr/serie/hercule-poirot/saison-2': 'V3',
	'/fr/serie/derry-girls/saison-2': 'V1',
	'/fr/serie/downton-abbey/saison-5': 'V2',
	'/fr/serie/haunted-hotel/saison-1': 'V3',
	'/fr/serie/chucky/saison-3': 'V1',
	'/fr/serie/hunters/saison-2': 'V2',
	'/fr/serie/guillermo-del-toros-cabinet-of-curiosities/saison-1': 'V3',
	'/fr/serie/blacklist/saison-5': 'V1',
	'/fr/serie/house-of-cards-2013/saison-5': 'V2',
	'/fr/serie/doctor-who-1963/saison-1': 'V3',
	'/fr/serie/diabolik-lovers/saison-1': 'V1',
	'/fr/serie/emily-in-paris/saison-2': 'V2',
	'/fr/serie/flash/saison-3': 'V3',
	'/fr/serie/archer/saison-2': 'V1',
	'/fr/serie/fool-me-once/saison-1': 'V2',
	'/fr/serie/greys-anatomy/saison-14': 'V3',
	'/fr/serie/bojack-horseman/saison-6': 'V1',
	'/fr/serie/based-on-a-true-story/saison-1': 'V2',
	'/fr/serie/haikyu/saison-4': 'V3',
	'/fr/serie/fi/saison-1': 'V1',
	'/fr/serie/boruto-naruto-next-generations/saison-2': 'V2',
	'/fr/serie/andromeda/saison-1': 'V3',
	'/fr/serie/american-monster/saison-8': 'V1',
	'/fr/serie/ceremonie-des-oscars/saison-1': 'V2',
	'/fr/serie/accidente/saison-2': 'V3',
	'/fr/serie/billions/saison-3': 'V1',
	'/fr/serie/chicago-p-d/saison-8': 'V2',
	'/fr/serie/deadly-class/saison-1': 'V3',
	'/fr/serie/futurama/saison-12': 'V1',
	'/fr/serie/clarksons-farm/saison-1': 'V2',
	'/fr/serie/domina/saison-1': 'V3',
	'/fr/serie/brokenwood/saison-10': 'V1',
	'/fr/serie/fate-stay-night/saison-1': 'V2',
	'/fr/serie/c-i-d/saison-2': 'V3',
	'/fr/serie/carnival-row/saison-1': 'V1',
	'/fr/serie/friends/saison-8': 'V2',
	'/fr/serie/bel-air/saison-1': 'V3',
	'/fr/serie/elementary/saison-6': 'V1',
	'/fr/serie/hudson-et-rex/saison-5': 'V2',
	'/fr/serie/fbi-most-wanted/saison-1': 'V3',
	'/fr/serie/citadel/saison-1': 'V1',
	'/fr/serie/enen-no-shouboutai-fire-force/saison-2': 'V2',
	'/fr/serie/godfather-of-harlem/saison-3': 'V3',
	'/fr/serie/columbo/saison-7': 'V1',
	'/fr/serie/heartland/saison-18': 'V2',
	'/fr/serie/fear-the-walking-dead/saison-3': 'V3',
	'/fr/serie/godless/saison-1': 'V1',
	'/fr/serie/generation-kill/saison-1': 'V2',
	'/fr/serie/anne/saison-1': 'V3',
	'/fr/serie/a-shop-for-killers/saison-1': 'V1',
	'/fr/serie/alska-mig/saison-1': 'V2',
	'/fr/serie/britannia/saison-1': 'V3',
	'/fr/serie/arrow/saison-3': 'V1',
	'/fr/serie/fear-the-walking-dead/saison-6': 'V2',
	'/fr/serie/glee/saison-1': 'V3',
	'/fr/serie/accused-2023/saison-2': 'V1',
	'/fr/serie/desperate-housewives/saison-8': 'V2',
	'/fr/serie/daldal/saison-1': 'V3',
	'/fr/serie/alien-theory/saison-2': 'V1',
	'/fr/serie/defendre-jacob/saison-1': 'V2',
	'/fr/serie/ginny-and-georgia/saison-2': 'V3',
	'/fr/serie/friday-night-lights/saison-2': 'V1',
	'/fr/serie/echo/saison-1': 'V2',
	'/fr/serie/in-treatment/saison-1': 'V3',
	'/fr/serie/californication/saison-7': 'V1',
	'/fr/serie/future-man/saison-3': 'V2',
	'/fr/serie/bosch/saison-6': 'V3',
	'/fr/serie/coroner/saison-1': 'V1',
	'/fr/serie/furies-0/saison-1': 'V2',
	'/fr/serie/harley-quinn/saison-5': 'V3',
	'/fr/serie/chicago-fire/saison-7': 'V1',
	'/fr/serie/dating-naked/saison-1': 'V2',
	'/fr/serie/banshee/saison-4': 'V3',
	'/fr/serie/american-gods/saison-2': 'V1',
	'/fr/serie/harry-wild/saison-1': 'V2',
	'/fr/serie/bleach/saison-16': 'V3',
	'/fr/serie/billy-the-kid/saison-1': 'V1',
	'/fr/serie/docteur-quinn-femme-medecin/saison-1': 'V2',
	'/fr/serie/bojack-horseman/saison-3': 'V3',
	'/fr/serie/house-of-cards-2013/saison-4': 'V1',
	'/fr/serie/house-of-cards-2013/saison-3': 'V2',
	'/fr/serie/dance-moms/saison-1': 'V3',
	'/fr/serie/el-juego-de-las-llaves/saison-1': 'V1',
	'/fr/serie/code-geass-lelouch-of-the-rebellion/saison-1': 'V2',
	'/fr/serie/and-just-like-that/saison-2': 'V3',
	'/fr/serie/dix-petits-negres/saison-1': 'V1',
	'/fr/serie/dreamworks-dragons/saison-1': 'V2',
	'/fr/serie/arrow/saison-5': 'V3',
	'/fr/serie/danmachi-familia-myth/saison-5': 'V1',
	'/fr/serie/hart-of-dixie/saison-1': 'V2',
	'/fr/serie/csi-vegas/saison-3': 'V3',
	'/fr/serie/esprits-criminels/saison-8': 'V1',
	'/fr/serie/broadchurch/saison-2': 'V2',
	'/fr/serie/choose-earth/saison-1': 'V3',
	'/fr/serie/flcl/saison-1': 'V1',
	'/fr/serie/blindspot/saison-3': 'V2',
	'/fr/serie/fubar/saison-1': 'V3',
	'/fr/serie/assassination-classroom/saison-1': 'V1',
	'/fr/serie/community/saison-6': 'V2',
	'/fr/serie/esprits-criminels/saison-7': 'V3',
	'/fr/serie/fate-apocrypha/saison-1': 'V1',
	'/fr/serie/dawson/saison-6': 'V2',
	'/fr/serie/ben-10-alien-force/saison-1': 'V3',
	'/fr/serie/fruits-basket/saison-1': 'V1',
	'/fr/serie/captain-tsubasa/saison-1': 'V2',
	'/fr/serie/acapulco/saison-4': 'V3',
	'/fr/serie/fury/saison-1': 'V1',
	'/fr/serie/ghosts-2019/saison-4': 'V2',
	'/fr/serie/1945-1953-de-la-guerre-mondiale-a-la-guerre-froide/saison-1': 'V3',
	'/fr/serie/goliath/saison-3': 'V1',
	'/fr/serie/escape-at-dannemora/saison-1': 'V2',
	'/fr/serie/dr-stone/saison-2': 'V3',
	'/fr/serie/chicago-fire/saison-8': 'V1',
	'/fr/serie/black-sails/saison-2': 'V2',
	'/fr/serie/alias/saison-1': 'V3',
	'/fr/serie/fairy-tail/saison-1': 'V1',
	'/fr/serie/9-1-1-lone-star/saison-4': 'V2',
	'/fr/serie/futurama/saison-6': 'V3',
	'/fr/serie/gossip-girl/saison-2': 'V1',
	'/fr/serie/feud/saison-2': 'V2',
	'/fr/serie/call-of-the-night/saison-1': 'V3',
	'/fr/serie/blue-bloods/saison-11': 'V1',
	'/fr/serie/el-marginal/saison-1': 'V2',
	'/fr/serie/bing/saison-1': 'V3',
	'/fr/serie/grace/saison-1': 'V1',
	'/fr/serie/black-clover/saison-4': 'V2',
	'/fr/serie/harry-wild/saison-3': 'V3',
	'/fr/serie/barry/saison-4': 'V1',
	'/fr/serie/family-guy/saison-5': 'V2',
	'/fr/serie/daria/saison-1': 'V3',
	'/fr/serie/hotel-costiera/saison-1': 'V1',
	'/fr/serie/eureka/saison-1': 'V2',
	'/fr/serie/buffy-contre-les-vampires/saison-4': 'V3',
	'/fr/serie/clarksons-farm/saison-3': 'V1',
	'/fr/serie/bodkin/saison-1': 'V2',
	'/fr/serie/childhoods-end-les-enfants-dicare/saison-1': 'V3',
	'/fr/serie/friday-night-lights/saison-4': 'V1',
	'/fr/serie/bleach-thousand-year-blood-war/saison-3': 'V2',
	'/fr/serie/goblin-slayer/saison-1': 'V3',
	'/fr/serie/doom-patrol/saison-3': 'V1',
	'/fr/serie/futurama/saison-1': 'V2',
	'/fr/serie/gilmore-girls/saison-5': 'V3',
	'/fr/serie/heirs-of-the-night/saison-1': 'V1',
	'/fr/serie/goblin-slayer/saison-2': 'V2',
	'/fr/serie/a-woman-of-substance/saison-1': 'V3',
	'/fr/serie/grantchester/saison-5': 'V1',
	'/fr/serie/doctor-who/saison-9': 'V2',
	'/fr/serie/buffy-contre-les-vampires/saison-7': 'V3',
	'/fr/serie/girls/saison-1': 'V1',
	'/fr/serie/da-vincis-demons/saison-1': 'V2',
	'/fr/serie/black-snow/saison-2': 'V3',
	'/fr/serie/dragons-par-dela-les-rives/saison-5': 'V1',
	'/fr/serie/feud/saison-1': 'V2',
	'/fr/serie/columbo/saison-4': 'V3',
	'/fr/serie/astrid-et-raphaelle/saison-3': 'V1',
	'/fr/serie/extraordinary-attorney-woo/saison-1': 'V2',
	'/fr/serie/dawson/saison-3': 'V3',
	'/fr/serie/evil-lives-here/saison-17': 'V1',
	'/fr/serie/empress-ki/saison-1': 'V2',
	'/fr/serie/historys-greatest-mysteries/saison-1': 'V3',
	'/fr/serie/doctor-who/saison-10': 'V1',
	'/fr/serie/castlevania/saison-1': 'V2',
	'/fr/serie/captain-tsubasa/saison-2': 'V3',
	'/fr/serie/heroes/saison-4': 'V1',
	'/fr/serie/black-sails/saison-4': 'V2',
	'/fr/serie/furia-2025/saison-1': 'V3',
	'/fr/serie/brandon-rogers-is-deaed/saison-1': 'V1',
	'/fr/serie/berserk-2016/saison-1': 'V2',
	'/fr/serie/call-the-midwife/saison-2': 'V3',
	'/fr/serie/houdini/saison-1': 'V1',
	'/fr/serie/hudson-et-rex/saison-4': 'V2',
	'/fr/serie/hanna/saison-1': 'V3',
	'/fr/serie/dragon-ball-gt/saison-1': 'V1',
	'/fr/serie/fake-profile/saison-1': 'V2',
	'/fr/serie/1670/saison-2': 'V3',
	'/fr/serie/borgen-une-femme-au-pouvoir/saison-4': 'V1',
	'/fr/serie/highlander/saison-3': 'V2',
	'/fr/serie/family-guy/saison-12': 'V3',
	'/fr/serie/captain-tsubasa-olive-et-tom/saison-1': 'V1',
	'/fr/serie/blue-bloods/saison-4': 'V2',
	'/fr/serie/baylen-out-loud/saison-1': 'V3',
	'/fr/serie/call-the-midwife/saison-5': 'V1',
	'/fr/serie/haven/saison-1': 'V2',
	'/fr/serie/brokenwood/saison-1': 'V3',
	'/fr/serie/buffy-contre-les-vampires/saison-5': 'V1',
	'/fr/serie/curb-your-enthusiasm/saison-12': 'V2',
	'/fr/serie/call-the-midwife/saison-4': 'V3',
	'/fr/serie/droners/saison-1': 'V1',
	'/fr/serie/batwoman/saison-1': 'V2',
	'/fr/serie/24/saison-2': 'V3',
	'/fr/serie/friday-night-lights/saison-3': 'V1',
	'/fr/serie/inazuma-eleven/saison-1': 'V2',
	'/fr/serie/i-think-you-should-leave-with-tim-robinson/saison-1': 'V3',
	'/fr/serie/family-guy/saison-18': 'V1',
	'/fr/serie/celtics-city/saison-1': 'V2',
	'/fr/serie/cheers/saison-2': 'V3',
	'/fr/serie/fbi-most-wanted/saison-3': 'V1',
	'/fr/serie/alfred-hitchcock-presente/saison-7': 'V2',
	'/fr/serie/hercule-poirot/saison-5': 'V3',
	'/fr/serie/agents-du-mystere/saison-1': 'V1',
	'/fr/serie/au-dela-du-reel-laventure-continue/saison-1': 'V2',
	'/fr/serie/batman-la-serie-animee/saison-2': 'V3',
	'/fr/serie/bleach-thousand-year-blood-war/saison-1': 'V1',
	'/fr/serie/family-guy/saison-3': 'V2',
	'/fr/serie/dcs-legends-of-tomorrow/saison-7': 'V3',
	'/fr/serie/akame-ga-kill/saison-1': 'V1',
	'/fr/serie/blue-bloods/saison-7': 'V2',
	'/fr/serie/air-disasters/saison-1': 'V3',
	'/fr/serie/dites-moi-princesse/saison-1': 'V1',
	'/fr/serie/chicago-fire/saison-6': 'V2',
	'/fr/serie/darling-in-the-franxx/saison-1': 'V3',
	'/fr/serie/high-school-dxd/saison-1': 'V1',
	'/fr/serie/dead-to-me/saison-1': 'V2',
	'/fr/serie/futurama/saison-4': 'V3',
	'/fr/serie/beauty-in-black/saison-1': 'V1',
	'/fr/serie/dawson/saison-4': 'V2',
	'/fr/serie/avatar-la-legende-de-korra/saison-2': 'V3',
	'/fr/serie/b-r-i/saison-1': 'V1',
	'/fr/serie/floogals/saison-1': 'V2',
	'/fr/serie/arabesque/saison-7': 'V3',
	'/fr/serie/highlander/saison-2': 'V1',
	'/fr/serie/barry/saison-2': 'V2',
	'/fr/serie/battlestar-galactica-mini-serie/saison-1': 'V3',
	'/fr/serie/bob-leponge-lile-karate/saison-2': 'V1',
	'/fr/serie/csi-vegas/saison-1': 'V2',
	'/fr/serie/english-teacher/saison-1': 'V3',
	'/fr/serie/hart-of-dixie/saison-2': 'V1',
	'/fr/serie/hantise/saison-1': 'V2',
	'/fr/serie/family-guy/saison-9': 'V3',
	'/fr/serie/adventure-time/saison-6': 'V1',
	'/fr/serie/family-guy/saison-2': 'V2',
	'/fr/serie/gotham-knights/saison-1': 'V3',
	'/fr/serie/hjem-til-jul/saison-3': 'V1',
	'/fr/serie/esprits-criminels/saison-9': 'V2',
	'/fr/serie/brandon-rogers-is-deaed/saison-2': 'V3',
	'/fr/serie/ill-become-a-villainess-that-will-go-down-in-history-the-more-of-a-villainess-i-become-the-more-the-prince-will-dote-on-me/saison-1':
		'V1',
	'/fr/serie/flash/saison-5': 'V2',
	'/fr/serie/curb-your-enthusiasm/saison-2': 'V3',
	'/fr/serie/flowers-in-the-attic-the-origin/saison-1': 'V1',
	'/fr/serie/bluey/saison-2': 'V2',
	'/fr/serie/coroner/saison-4': 'V3',
	'/fr/serie/baby/saison-1': 'V1',
	'/fr/serie/harlots/saison-1': 'V2',
	'/fr/serie/dark-matter/saison-1': 'V3',
	'/fr/serie/farscape/saison-4': 'V1',
	'/fr/serie/des-agents-tres-speciaux/saison-1': 'V2',
	'/fr/serie/gossip-girl/saison-3': 'V3',
	'/fr/serie/atlanta/saison-3': 'V1',
	'/fr/serie/dugum/saison-1': 'V2',
	'/fr/serie/fate-zero/saison-1': 'V3',
	'/fr/serie/batman-la-serie-animee/saison-4': 'V1',
	'/fr/serie/frasier/saison-4': 'V2',
	'/fr/serie/channel-zero/saison-1': 'V3',
	'/fr/serie/bobs-burgers/saison-1': 'V1',
	'/fr/serie/chucky/saison-1': 'V2',
	'/fr/serie/bosch/saison-4': 'V3',
	'/fr/serie/avenida-brasil/saison-1': 'V1',
	'/fr/serie/asterix-et-obelix-le-combat-des-chefs/saison-1': 'V2',
	'/fr/serie/dating-naked-draguer-nu/saison-2': 'V3',
	'/fr/serie/dragon-ball/saison-3': 'V1',
	'/fr/serie/criminal-record/saison-1': 'V2',
	'/fr/serie/beastars/saison-2': 'V3',
	'/fr/serie/colony/saison-1': 'V1',
	'/fr/serie/fatal-seduction/saison-2': 'V2',
	'/fr/serie/a-business-proposal/saison-1': 'V3',
	'/fr/serie/cosmocats/saison-1': 'V1',
	'/fr/serie/gilmore-girls-a-year-in-the-life/saison-1': 'V2',
	'/fr/serie/adventure-time/saison-2': 'V3',
	'/fr/serie/between-the-world-and-us/saison-1': 'V1',
	'/fr/serie/fbi-international/saison-2': 'V2',
	'/fr/serie/barbares/saison-1': 'V3',
	'/fr/serie/24/saison-7': 'V1',
	'/fr/serie/el-juego-de-las-llaves/saison-3': 'V2',
	'/fr/serie/el-inocente/saison-1': 'V3',
	'/fr/serie/des-vivants/saison-1': 'V1',
	'/fr/serie/blood-of-zeus/saison-3': 'V2',
	'/fr/serie/gupi/saison-1': 'V3',
	'/fr/serie/dear-child/saison-1': 'V1',
	'/fr/serie/histoires-fantastiques-2020/saison-1': 'V2',
	'/fr/serie/arabesque/saison-10': 'V3',
	'/fr/serie/harley-quinn/saison-3': 'V1',
	'/fr/serie/30-rock/saison-3': 'V2',
	'/fr/serie/hellsing-ultimate/saison-1': 'V3',
	'/fr/serie/heartstopper/saison-1': 'V1',
	'/fr/serie/alert-missing-persons-unit/saison-1': 'V2',
	'/fr/serie/criminal-code/saison-2': 'V3',
	'/fr/serie/call-the-midwife/saison-7': 'V1',
	'/fr/serie/black-sails/saison-3': 'V2',
	'/fr/serie/evil-lives-here/saison-1': 'V3',
	'/fr/serie/hercule-poirot/saison-13': 'V1',
	'/fr/serie/frasier/saison-7': 'V2',
	'/fr/serie/adventure-time/saison-10': 'V3',
	'/fr/serie/24/saison-4': 'V1',
	'/fr/serie/danmachi-familia-myth/saison-1': 'V2',
	'/fr/serie/doctor-odyssey/saison-1': 'V3',
	'/fr/serie/gossip-girl/saison-6': 'V1',
	'/fr/serie/grantchester/saison-6': 'V2',
	'/fr/serie/american-horror-stories/saison-2': 'V3',
	'/fr/serie/creepshow/saison-1': 'V1',
	'/fr/serie/atlanta/saison-4': 'V2',
	'/fr/serie/dune/saison-1': 'V3',
	'/fr/serie/call-the-midwife/saison-3': 'V1',
	'/fr/serie/boardwalk-empire/saison-2': 'V2',
	'/fr/serie/adventure-time/saison-3': 'V3',
	'/fr/serie/family-guy/saison-7': 'V1',
	'/fr/serie/below-deck/saison-12': 'V2',
	'/fr/serie/godfather-of-harlem/saison-2': 'V3',
	'/fr/serie/anyway-im-falling-in-love-with-you/saison-1': 'V1',
	'/fr/serie/bates-motel/saison-5': 'V2',
	'/fr/serie/brassic/saison-1': 'V3',
	'/fr/serie/etoile/saison-1': 'V1',
	'/fr/serie/cauchemar-en-cuisine-usa/saison-1': 'V2',
	'/fr/serie/fear-the-walking-dead/saison-5': 'V3',
	'/fr/serie/di-fu-shao-nian-hua-zi-kun/saison-1': 'V1',
	'/fr/serie/blood-c/saison-1': 'V2',
	'/fr/serie/ghost-whisperer/saison-2': 'V3',
	'/fr/serie/astrid-et-raphaelle/saison-4': 'V1',
	'/fr/serie/blue-bloods/saison-8': 'V2',
	'/fr/serie/entrevias/saison-4': 'V3',
	'/fr/serie/a-star-brighter-than-the-sun/saison-1': 'V1',
	'/fr/serie/burn-notice/saison-1': 'V2',
	'/fr/serie/cheers/saison-5': 'V3',
	'/fr/serie/docteur-foster/saison-2': 'V1',
	'/fr/serie/colin-from-accounts/saison-1': 'V2',
	'/fr/serie/elite/saison-6': 'V3',
	'/fr/serie/12-monkeys/saison-2': 'V1',
	'/fr/serie/cracked/saison-1': 'V2',
	'/fr/serie/ben-and-hollys-little-kingdom/saison-2': 'V3',
	'/fr/serie/carnival-row/saison-2': 'V1',
	'/fr/serie/fullmetal-alchemist/saison-1': 'V2',
	'/fr/serie/heartbreak-high/saison-1': 'V3',
	'/fr/serie/fan-ma-ren-ya/saison-2': 'V1',
	'/fr/serie/avenue-5/saison-1': 'V2',
	'/fr/serie/bleach/saison-4': 'V3',
	'/fr/serie/7-a-la-maison/saison-1': 'V1',
	'/fr/serie/departure/saison-1': 'V2',
	'/fr/serie/capo-ascension-au-pouvoir/saison-1': 'V3',
	'/fr/serie/frasier/saison-11': 'V1',
	'/fr/serie/elite/saison-8': 'V2',
	'/fr/serie/elite/saison-5': 'V3',
	'/fr/serie/family-guy/saison-17': 'V1',
	'/fr/serie/hawaii-5-0/saison-4': 'V2',
	'/fr/serie/butterfly/saison-1': 'V3',
	'/fr/serie/desperate-housewives/saison-6': 'V1',
	'/fr/serie/critrhiin/saison-2': 'V2',
	'/fr/serie/gossip-girl/saison-4': 'V3',
	'/fr/serie/homecoming/saison-1': 'V1',
	'/fr/serie/courage-le-chien-froussard/saison-1': 'V2',
	'/fr/serie/im-not-a-robot/saison-1': 'V3',
	'/fr/serie/12-monkeys/saison-3': 'V1',
	'/fr/serie/head-over-heels/saison-1': 'V2',
	'/fr/serie/bleach/saison-3': 'V3',
	'/fr/serie/big-shot/saison-1': 'V1',
	'/fr/serie/dragons-the-nine-realms/saison-1': 'V2',
	'/fr/serie/big-mouth/saison-8': 'V3',
	'/fr/serie/confidence-queen/saison-1': 'V1',
	'/fr/serie/black-summer/saison-1': 'V2',
	'/fr/serie/after-life/saison-2': 'V3',
	'/fr/serie/charmed/saison-4': 'V1',
	'/fr/serie/icarly/saison-1': 'V2',
	'/fr/serie/flash/saison-6': 'V3',
	'/fr/serie/ally-mcbeal/saison-1': 'V1',
	'/fr/serie/family-guy/saison-11': 'V2',
	'/fr/serie/hercule-poirot/saison-4': 'V3',
	'/fr/serie/designated-survivor/saison-2': 'V1',
	'/fr/serie/columbo/saison-6': 'V2',
	'/fr/serie/el-encargado/saison-1': 'V3',
	'/fr/serie/anthony-bourdain-no-reservations/saison-2': 'V1',
	'/fr/serie/deadwater-fell/saison-1': 'V2',
	'/fr/serie/eastbound-and-down/saison-1': 'V3',
	'/fr/serie/critrhiin/saison-1': 'V1',
	'/fr/serie/amsterdam-empire/saison-1': 'V2',
	'/fr/serie/another-life/saison-1': 'V3',
	'/fr/serie/heartstopper/saison-2': 'V1',
	'/fr/serie/flight-of-the-conchords/saison-1': 'V2',
	'/fr/serie/destin-la-saga-winx/saison-1': 'V3',
	'/fr/serie/constantine/saison-1': 'V1',
	'/fr/serie/90210-beverly-hills-nouvelle-generation/saison-1': 'V2',
	'/fr/serie/gentleman-jack/saison-1': 'V3',
	'/fr/serie/adventure-time/saison-4': 'V1',
	'/fr/serie/defiance/saison-1': 'V2',
	'/fr/serie/aux-cotes-du-mal/saison-1': 'V3',
	'/fr/serie/dcs-legends-of-tomorrow/saison-6': 'V1',
	'/fr/serie/blue-exorcist/saison-5': 'V2',
	'/fr/serie/haggyo-2017/saison-1': 'V3',
	'/fr/serie/30-rock/saison-5': 'V1',
	'/fr/serie/heidi-1978/saison-1': 'V2',
	'/fr/serie/black-ish/saison-8': 'V3',
	'/fr/serie/happiness-kr/saison-1': 'V1',
	'/fr/serie/csi-vegas/saison-2': 'V2',
	'/fr/serie/annika/saison-1': 'V3',
	'/fr/serie/beyond-the-bar/saison-1': 'V1',
	'/fr/serie/genius/saison-4': 'V2',
	'/fr/serie/dans-leur-regard/saison-1': 'V3',
	'/fr/serie/hell-on-wheels/saison-3': 'V1',
	'/fr/serie/haikyu/saison-3': 'V2',
	'/fr/serie/cobra-kai/saison-2': 'V3',
	'/fr/serie/cheers/saison-7': 'V1',
	'/fr/serie/aspirants/saison-1': 'V2',
	'/fr/serie/hero-without-a-class-who-even-needs-skills/saison-1': 'V3',
	'/fr/serie/droles-de-dames/saison-1': 'V1',
	'/fr/serie/alex-rider/saison-1': 'V2',
	'/fr/serie/docteure-doogie/saison-1': 'V3',
	'/fr/serie/farscape/saison-3': 'V1',
	'/fr/serie/eyewitness/saison-1': 'V2',
	'/fr/serie/berlin-station/saison-1': 'V3',
	'/fr/serie/dr-slump/saison-1': 'V1',
	'/fr/serie/hercule-poirot/saison-12': 'V2',
	'/fr/serie/archive-81/saison-1': 'V3',
	'/fr/serie/babylon-5/saison-3': 'V1',
	'/fr/serie/coroner/saison-2': 'V2',
	'/fr/serie/24/saison-6': 'V3',
	'/fr/serie/arrow/saison-8': 'V1',
	'/fr/serie/apples-never-fall/saison-1': 'V2',
	'/fr/serie/hemlock-grove/saison-1': 'V3',
	'/fr/serie/charmed/saison-8': 'V1',
	'/fr/serie/bienvenue-chez-les-huang/saison-1': 'V2',
	'/fr/serie/accused/saison-1': 'V3',
	'/fr/serie/babylon-berlin/saison-2': 'V1',
	'/fr/serie/bitch-x-rich/saison-1': 'V2',
	'/fr/serie/below-deck/saison-1': 'V3',
	'/fr/serie/black-lagoon/saison-1': 'V1',
	'/fr/serie/company-retreat/saison-1': 'V2',
	'/fr/serie/brokenwood/saison-2': 'V3',
	'/fr/serie/fate-zero/saison-2': 'V1',
	'/fr/serie/henry-danger/saison-5': 'V2',
	'/fr/serie/angela/saison-1': 'V3',
	'/fr/serie/envieuse/saison-3': 'V1',
	'/fr/serie/impulse/saison-1': 'V2',
	'/fr/serie/batwoman/saison-3': 'V3',
	'/fr/serie/dragons-par-dela-les-rives/saison-1': 'V1',
	'/fr/serie/borgen-une-femme-au-pouvoir/saison-3': 'V2',
	'/fr/serie/battlestar-galactica/saison-3': 'V3',
	'/fr/serie/edens-zero/saison-2': 'V1',
	'/fr/serie/ben-10/saison-3': 'V2',
	'/fr/serie/evil-lives-here/saison-9': 'V3',
	'/fr/serie/angela-anaconda/saison-3': 'V1',
	'/fr/serie/cold-case-affaires-classees/saison-2': 'V2',
	'/fr/serie/as-the-crow-flies/saison-3': 'V3',
	'/fr/serie/drawn-together/saison-2': 'V1',
	'/fr/serie/dcs-legends-of-tomorrow/saison-2': 'V2',
	'/fr/serie/buried-in-the-backyard/saison-6': 'V3',
	'/fr/serie/hell-on-wheels/saison-5': 'V1',
	'/fr/serie/classroom-of-the-elite/saison-1': 'V2',
	'/fr/serie/arabesque/saison-9': 'V3',
	'/fr/serie/ex-on-the-beach/saison-9': 'V1',
	'/fr/serie/curb-your-enthusiasm/saison-4': 'V2',
	'/fr/serie/avatar-la-legende-de-korra/saison-4': 'V3',
	'/fr/serie/brokenwood/saison-3': 'V1',
	'/fr/serie/bob-leponge-lile-karate/saison-5': 'V2',
	'/fr/serie/bupkis/saison-1': 'V3',
	'/fr/serie/gomorrah/saison-4': 'V1',
	'/fr/serie/daria/saison-5': 'V2',
	'/fr/serie/death-and-other-details/saison-1': 'V3',
	'/fr/serie/earl/saison-4': 'V1',
	'/fr/serie/angel/saison-2': 'V2',
	'/fr/serie/delhi-crime/saison-3': 'V3',
	'/fr/serie/girl-from-nowhere/saison-2': 'V1',
	'/fr/serie/elite/saison-4': 'V2',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-15': 'V3',
	'/fr/serie/boardwalk-empire/saison-4': 'V1',
	'/fr/serie/highlander/saison-1': 'V2',
	'/fr/serie/californication/saison-6': 'V3',
	'/fr/serie/il-cacciatore/saison-1': 'V1',
	'/fr/serie/bleach-thousand-year-blood-war/saison-2': 'V2',
	'/fr/serie/i-may-destroy-you/saison-1': 'V3',
	'/fr/serie/frasier/saison-3': 'V1',
	'/fr/serie/danmachi-familia-myth/saison-2': 'V2',
	'/fr/serie/chuck/saison-3': 'V3',
	'/fr/serie/brokenwood/saison-7': 'V1',
	'/fr/serie/diario-de-un-gigolo/saison-1': 'V2',
	'/fr/serie/green-porno/saison-1': 'V3',
	'/fr/serie/deadwind/saison-1': 'V1',
	'/fr/serie/das-boot/saison-3': 'V2',
	'/fr/serie/bob-leponge-lile-karate/saison-11': 'V3',
	'/fr/serie/dragon-ball/saison-2': 'V1',
	'/fr/serie/britannia/saison-3': 'V2',
	'/fr/serie/family-guy/saison-6': 'V3',
	'/fr/serie/charmed/saison-2': 'V1',
	'/fr/serie/human-target-la-cible/saison-1': 'V2',
	'/fr/serie/deutschland-83/saison-1': 'V3',
	'/fr/serie/hajime-no-ippo/saison-3': 'V1',
	'/fr/serie/fruits-basket/saison-2': 'V2',
	'/fr/serie/fbi-international/saison-3': 'V3',
	'/fr/serie/clarksons-farm/saison-2': 'V1',
	'/fr/serie/exploding-kittens/saison-1': 'V2',
	'/fr/serie/grand-hotel/saison-1': 'V3',
	'/fr/serie/frasier/saison-5': 'V1',
	'/fr/serie/backstreet-rookie/saison-1': 'V2',
	'/fr/serie/conan-obrien-must-go/saison-2': 'V3',
	'/fr/serie/boardwalk-empire/saison-3': 'V1',
	'/fr/serie/chi-regarding-the-movement-of-the-earth/saison-1': 'V2',
	'/fr/serie/hawaii-5-0/saison-6': 'V3',
	'/fr/serie/evil-lives-here/saison-13': 'V1',
	'/fr/serie/borgia/saison-1': 'V2',
	'/fr/serie/gyeongiroun-somun/saison-2': 'V3',
	'/fr/serie/call-my-agent/saison-1': 'V1',
	'/fr/serie/dragon-raja-the-blazing-dawn/saison-1': 'V2',
	'/fr/serie/alias/saison-2': 'V3',
	'/fr/serie/heartbreak-high/saison-2': 'V1',
	'/fr/serie/dublin-murders/saison-1': 'V2',
	'/fr/serie/connect/saison-1': 'V3',
	'/fr/serie/avatar-la-legende-de-korra/saison-3': 'V1',
	'/fr/serie/il-capo-dei-capi/saison-1': 'V2',
	'/fr/serie/ever-after-high/saison-1': 'V3',
	'/fr/serie/black-butler/saison-5': 'V1',
	'/fr/serie/big-hero-6-the-series/saison-2': 'V2',
	'/fr/serie/dead-to-me/saison-3': 'V3',
	'/fr/serie/amour-eternel/saison-2': 'V1',
	'/fr/serie/henry-danger/saison-1': 'V2',
	'/fr/serie/crimes-a-la-une/saison-1': 'V3',
	'/fr/serie/13-reasons-why/saison-2': 'V1',
	'/fr/serie/bull-2016/saison-2': 'V2',
	'/fr/serie/arrete-de-me-chauffer-nagatoro/saison-1': 'V3',
	'/fr/serie/chez-maupassant/saison-1': 'V1',
	'/fr/serie/batman-2004/saison-1': 'V2',
	'/fr/serie/arabesque/saison-6': 'V3',
	'/fr/serie/chuck/saison-4': 'V1',
	'/fr/serie/alfred-hitchcock-presente/saison-3': 'V2',
	'/fr/serie/euracaca-waikiki/saison-1': 'V3',
	'/fr/serie/domestic-na-kanojo/saison-1': 'V1',
	'/fr/serie/drake-and-josh/saison-1': 'V2',
	'/fr/serie/cauchemar-en-cuisine-usa/saison-8': 'V3',
	'/fr/serie/dragon-ball-z/saison-9': 'V1',
	'/fr/serie/archer/saison-13': 'V2',
	'/fr/serie/ash-vs-evil-dead/saison-2': 'V3',
	'/fr/serie/heweliusz/saison-1': 'V1',
	'/fr/serie/four-more-shots-please/saison-4': 'V2',
	'/fr/serie/andromeda/saison-2': 'V3',
	'/fr/serie/american-dad/saison-13': 'V1',
	'/fr/serie/american-monster/saison-5': 'V2',
	'/fr/serie/family-guy/saison-13': 'V3',
	'/fr/serie/hudson-et-rex/saison-6': 'V1',
	'/fr/serie/below-deck-down-under/saison-1': 'V2',
	'/fr/serie/cheers/saison-3': 'V3',
	'/fr/serie/hart-of-dixie/saison-3': 'V1',
	'/fr/serie/britannia/saison-2': 'V2',
	'/fr/serie/alone/saison-6': 'V3',
	'/fr/serie/bonanza/saison-1': 'V1',
	'/fr/serie/chucky/saison-2': 'V2',
	'/fr/serie/gantz/saison-1': 'V3',
	'/fr/serie/family-law/saison-1': 'V1',
	'/fr/serie/all-the-light-we-cannot-see/saison-1': 'V2',
	'/fr/serie/boru/saison-1': 'V3',
	'/fr/serie/arifureta/saison-1': 'V1',
	'/fr/serie/c-i-d/saison-1': 'V2',
	'/fr/serie/follow-me/saison-1': 'V3',
	'/fr/serie/das-boot/saison-4': 'V1',
	'/fr/serie/hudson-et-rex/saison-2': 'V2',
	'/fr/serie/chuck/saison-5': 'V3',
	'/fr/serie/air-disasters/saison-9': 'V1',
	'/fr/serie/bull-2016/saison-6': 'V2',
	'/fr/serie/cold-case-affaires-classees/saison-7': 'V3',
	'/fr/serie/griselda/saison-1': 'V1',
	'/fr/serie/geombeobnamnyeo/saison-1': 'V2',
	'/fr/serie/big-mouth/saison-3': 'V3',
	'/fr/serie/from-scratch/saison-1': 'V1',
	'/fr/serie/fairy-tail/saison-8': 'V2',
	'/fr/serie/gotham/saison-4': 'V3',
	'/fr/serie/docteur-quinn-femme-medecin/saison-3': 'V1',
	'/fr/serie/boy-meets-world/saison-7': 'V2',
	'/fr/serie/brassic/saison-5': 'V3',
	'/fr/serie/berserk-the-golden-age-arc-memorial-edition/saison-1': 'V1',
	'/fr/serie/bref/saison-1': 'V2',
	'/fr/serie/castlevania/saison-2': 'V3',
	'/fr/serie/barbares/saison-2': 'V1',
	'/fr/serie/curb-your-enthusiasm/saison-9': 'V2',
	'/fr/serie/careme/saison-1': 'V3',
	'/fr/serie/alert-missing-persons-unit/saison-2': 'V1',
	'/fr/serie/dos-tumbas/saison-1': 'V2',
	'/fr/serie/community/saison-4': 'V3',
	'/fr/serie/glitter-force/saison-1': 'V1',
	'/fr/serie/alerte-a-malibu/saison-1': 'V2',
	'/fr/serie/enfants-stars-un-predateur-en-coulisses/saison-1': 'V3',
	'/fr/serie/cruel-summer/saison-1': 'V1',
	'/fr/serie/9-1-1-lone-star/saison-2': 'V2',
	'/fr/serie/blue-bloods/saison-5': 'V3',
	'/fr/serie/durarara/saison-2': 'V1',
	'/fr/serie/hand-of-god/saison-2': 'V2',
	'/fr/serie/alta-mar/saison-2': 'V3',
	'/fr/serie/9-1-1-lone-star/saison-3': 'V1',
	'/fr/serie/another-self/saison-1': 'V2',
	'/fr/serie/big-mouth/saison-2': 'V3',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-12': 'V1',
	'/fr/serie/brokenwood/saison-8': 'V2',
	'/fr/serie/glee/saison-2': 'V3',
	'/fr/serie/chefs-table-pizza/saison-1': 'V1',
	'/fr/serie/benza-english/saison-1': 'V2',
	'/fr/serie/ash-vs-evil-dead/saison-3': 'V3',
	'/fr/serie/13-reasons-why/saison-3': 'V1',
	'/fr/serie/channel-zero/saison-2': 'V2',
	'/fr/serie/cardinal/saison-2': 'V3',
	'/fr/serie/3/saison-1': 'V1',
	'/fr/serie/harrow/saison-1': 'V2',
	'/fr/serie/danny-phantom/saison-2': 'V3',
	'/fr/serie/harry-potter-wizards-of-baking/saison-2': 'V1',
	'/fr/serie/geu-namjayi-gieogbeob/saison-1': 'V2',
	'/fr/serie/7th-time-loop-the-villainess-enjoys-a-carefree-life-married-to-her-worst-enemy/saison-1': 'V3',
	'/fr/serie/four-more-shots-please/saison-1': 'V1',
	'/fr/serie/bobs-burgers/saison-5': 'V2',
	'/fr/serie/ghosts-2019/saison-2': 'V3',
	'/fr/serie/bleach/saison-5': 'V1',
	'/fr/serie/a-la-recherche-de/saison-1': 'V2',
	'/fr/serie/dickinson/saison-2': 'V3',
	'/fr/serie/bungou-stray-dogs/saison-2': 'V1',
	'/fr/serie/euphoria-capitulos-especiales/saison-1': 'V2',
	'/fr/serie/bobs-burgers/saison-11': 'V3',
	'/fr/serie/alerte-a-malibu/saison-2': 'V1',
	'/fr/serie/heartland/saison-2': 'V2',
	'/fr/serie/final-space/saison-1': 'V3',
	'/fr/serie/good-behavior/saison-1': 'V1',
	'/fr/serie/disappeared/saison-10': 'V2',
	'/fr/serie/heirs-of-the-night/saison-2': 'V3',
	'/fr/serie/continuum/saison-2': 'V1',
	'/fr/serie/doraemon/saison-1': 'V2',
	'/fr/serie/dr-death/saison-1': 'V3',
	'/fr/serie/citrus/saison-1': 'V1',
	'/fr/serie/bloodline/saison-1': 'V2',
	'/fr/serie/21-jump-street/saison-4': 'V3',
	'/fr/serie/demain-a-la-une/saison-1': 'V1',
	'/fr/serie/father-ted/saison-1': 'V2',
	'/fr/serie/dakaichi-my-number-1/saison-1': 'V3',
	'/fr/serie/big-mouth/saison-1': 'V1',
	'/fr/serie/hanazakari-no-kimitachi-e/saison-1': 'V2',
	'/fr/serie/harley-quinn/saison-4': 'V3',
	'/fr/serie/black-ish/saison-7': 'V1',
	'/fr/serie/hawaii-5-0/saison-7': 'V2',
	'/fr/serie/fit-for-a-killer/saison-1': 'V3',
	'/fr/serie/dance-academy/saison-3': 'V1',
	'/fr/serie/black-clover/saison-3': 'V2',
	'/fr/serie/episodes/saison-5': 'V3',
	'/fr/serie/finally/saison-1': 'V1',
	'/fr/serie/90210-beverly-hills-nouvelle-generation/saison-2': 'V2',
	'/fr/serie/drake-and-josh/saison-3': 'V3',
	'/fr/serie/bobs-burgers/saison-14': 'V1',
	'/fr/serie/atypical/saison-1': 'V2',
	'/fr/serie/apocalypse-la-deuxieme-guerre-mondiale/saison-1': 'V3',
	'/fr/serie/episodes/saison-2': 'V1',
	'/fr/serie/heartland/saison-17': 'V2',
	'/fr/serie/covert-affairs/saison-5': 'V3',
	'/fr/serie/amour-gloire-et-beaute/saison-1': 'V1',
	'/fr/serie/hawaii-5-0/saison-10': 'V2',
	'/fr/serie/hierro/saison-1': 'V3',
	'/fr/serie/bleach/saison-15': 'V1',
	'/fr/serie/devious-maids/saison-1': 'V2',
	'/fr/serie/doctor-stranger/saison-1': 'V3',
	'/fr/serie/arabesque/saison-2': 'V1',
	'/fr/serie/arabesque/saison-3': 'V2',
	'/fr/serie/classroom-of-the-elite/saison-3': 'V3',
	'/fr/serie/degrassi-nouvelle-generation/saison-13': 'V1',
	'/fr/serie/i-know-this-much-is-true/saison-1': 'V2',
	'/fr/serie/craig-of-the-creek/saison-1': 'V3',
	'/fr/serie/des-2020/saison-1': 'V1',
	'/fr/serie/ed-edd-and-eddy/saison-1': 'V2',
	'/fr/serie/fairy-tail/saison-7': 'V3',
	'/fr/serie/alf/saison-4': 'V1',
	'/fr/serie/dragon-ball-z/saison-8': 'V2',
	'/fr/serie/i-am-a-killer/saison-1': 'V3',
	'/fr/serie/blindspot/saison-4': 'V1',
	'/fr/serie/citadel-diana/saison-1': 'V2',
	'/fr/serie/doctor-who-1963/saison-14': 'V3',
	'/fr/serie/dragon-ball/saison-4': 'V1',
	'/fr/serie/blindspot/saison-5': 'V2',
	'/fr/serie/anthony-bourdain-no-reservations/saison-1': 'V3',
	'/fr/serie/batman/saison-2': 'V1',
	'/fr/serie/grace-and-frankie/saison-5': 'V2',
	'/fr/serie/21-jump-street/saison-3': 'V3',
	'/fr/serie/fairy-tail/saison-6': 'V1',
	'/fr/serie/gate/saison-2': 'V2',
	'/fr/serie/doctors/saison-1': 'V3',
	'/fr/serie/dirilis-ertugrul/saison-2': 'V1',
	'/fr/serie/boardwalk-empire/saison-5': 'V2',
	'/fr/serie/channel-zero/saison-4': 'V3',
	'/fr/serie/humans/saison-2': 'V1',
	'/fr/serie/digimon/saison-2': 'V2',
	'/fr/serie/evil-lives-here/saison-2': 'V3',
	'/fr/serie/harry-potter-wizards-of-baking/saison-1': 'V1',
	'/fr/serie/better-things/saison-1': 'V2',
	'/fr/serie/hitler-et-les-nazis-le-proces-du-mal/saison-1': 'V3',
	'/fr/serie/alvinnn-et-les-chipmunks/saison-1': 'V1',
	'/fr/serie/cheers/saison-6': 'V2',
	'/fr/serie/annika/saison-2': 'V3',
	'/fr/serie/diagnostic-meurtre/saison-1': 'V1',
	'/fr/serie/di4ri/saison-1': 'V2',
	'/fr/serie/farscape/saison-2': 'V3',
	'/fr/serie/archer/saison-9': 'V1',
	'/fr/serie/harrow/saison-3': 'V2',
	'/fr/serie/family-guy/saison-16': 'V3',
	'/fr/serie/dcs-legends-of-tomorrow/saison-5': 'V1',
	'/fr/serie/bimil/saison-1': 'V2',
	'/fr/serie/alice-nevers-le-juge-est-une-femme/saison-1': 'V3',
	'/fr/serie/gossip-girl-2021/saison-1': 'V1',
	'/fr/serie/danny-phantom/saison-1': 'V2',
	'/fr/serie/californication/saison-5': 'V3',
	'/fr/serie/boss/saison-1': 'V1',
	'/fr/serie/hercule-poirot/saison-7': 'V2',
	'/fr/serie/cold-case-affaires-classees/saison-3': 'V3',
	'/fr/serie/a-girl-et-her-guard-dog/saison-1': 'V1',
	'/fr/serie/big-love/saison-1': 'V2',
	'/fr/serie/golden-kamui/saison-1': 'V3',
	'/fr/serie/beyblade-burst/saison-1': 'V1',
	'/fr/serie/bimilyi-sup/saison-1': 'V2',
	'/fr/serie/alone/saison-5': 'V3',
	'/fr/serie/au-royaume-des-fauves/saison-1': 'V1',
	'/fr/serie/atypical/saison-3': 'V2',
	'/fr/serie/forensic-files/saison-12': 'V3',
	'/fr/serie/aka-charlie-sheen/saison-1': 'V1',
	'/fr/serie/grizzy-et-les-lemmings/saison-1': 'V2',
	'/fr/serie/alf/saison-2': 'V3',
	'/fr/serie/emerald-city/saison-1': 'V1',
	'/fr/serie/cruel-summer/saison-2': 'V2',
	'/fr/serie/banana-fish/saison-1': 'V3',
	'/fr/serie/breakout-kings/saison-1': 'V1',
	'/fr/serie/24/saison-5': 'V2',
	'/fr/serie/digman/saison-1': 'V3',
	'/fr/serie/all-american/saison-1': 'V1',
	'/fr/serie/hell-on-wheels/saison-2': 'V2',
	'/fr/serie/crossing-lines/saison-3': 'V3',
	'/fr/serie/heroes/saison-2': 'V1',
	'/fr/serie/alfred-hitchcock-presente/saison-2': 'V2',
	'/fr/serie/hotel-portofino/saison-1': 'V3',
	'/fr/serie/dickinson/saison-3': 'V1',
	'/fr/serie/fleishman-is-in-trouble/saison-1': 'V2',
	'/fr/serie/hellbound/saison-2': 'V3',
	'/fr/serie/a-lepreuve-du-diable/saison-1': 'V1',
	'/fr/serie/batman-lalliance-des-heros/saison-3': 'V2',
	'/fr/serie/90-day-fiance/saison-1': 'V3',
	'/fr/serie/blade-runner-black-lotus/saison-1': 'V1',
	'/fr/serie/exit-2019/saison-1': 'V2',
	'/fr/serie/goodbye-dragon-life/saison-1': 'V3',
	'/fr/serie/heartland/saison-3': 'V1',
	'/fr/serie/continuum/saison-3': 'V2',
	'/fr/serie/dci-banks/saison-1': 'V3',
	'/fr/serie/city-on-a-hill/saison-1': 'V1',
	'/fr/serie/girls5eva/saison-1': 'V2',
	'/fr/serie/entrevias/saison-3': 'V3',
	'/fr/serie/championnes-a-tout-prix/saison-1': 'V1',
	'/fr/serie/doremon/saison-1': 'V2',
	'/fr/serie/g-e-o-mas-alla-del-limite/saison-1': 'V3',
	'/fr/serie/final-space/saison-3': 'V1',
	'/fr/serie/chasseurs-de-trolls/saison-1': 'V2',
	'/fr/serie/dance-moms/saison-6': 'V3',
	'/fr/serie/blue-exorcist/saison-2': 'V1',
	'/fr/serie/furia/saison-1': 'V2',
	'/fr/serie/divorce-lawyer/saison-2': 'V3',
	'/fr/serie/a-cooks-tour/saison-1': 'V1',
	'/fr/serie/danmachi-familia-myth/saison-4': 'V2',
	'/fr/serie/californication/saison-4': 'V3',
	'/fr/serie/candice-renoir/saison-1': 'V1',
	'/fr/serie/imposters/saison-1': 'V2',
	'/fr/serie/detective-conan/saison-2': 'V3',
	'/fr/serie/black-lightning/saison-1': 'V1',
	'/fr/serie/evil-lives-here/saison-6': 'V2',
	'/fr/serie/detective-conan/saison-4': 'V3',
	'/fr/serie/abysses/saison-1': 'V1',
	'/fr/serie/bull-2016/saison-5': 'V2',
	'/fr/serie/fairy-tail/saison-2': 'V3',
	'/fr/serie/anne/saison-3': 'V1',
	'/fr/serie/crime-scene-zero/saison-1': 'V2',
	'/fr/serie/air-disasters/saison-7': 'V3',
	'/fr/serie/emma/saison-1': 'V1',
	'/fr/serie/creeped-out/saison-1': 'V2',
	'/fr/serie/cheer-up/saison-1': 'V3',
	'/fr/serie/car-masters-de-la-rouille-a-lor/saison-6': 'V1',
	'/fr/serie/im-quitting-heroing/saison-1': 'V2',
	'/fr/serie/bakugan-battle-brawlers/saison-1': 'V3',
	'/fr/serie/dragon-ball-z/saison-6': 'V1',
	'/fr/serie/alfred-hitchcock-presente/saison-6': 'V2',
	'/fr/serie/baskets/saison-1': 'V3',
	'/fr/serie/angel/saison-4': 'V1',
	'/fr/serie/i-think-you-should-leave-with-tim-robinson/saison-3': 'V2',
	'/fr/serie/gordon-ramsay-bataille-de-chefs/saison-1': 'V3',
	'/fr/serie/californication/saison-3': 'V1',
	'/fr/serie/destin-la-saga-winx/saison-2': 'V2',
	'/fr/serie/baby-einstein-classics/saison-1': 'V3',
	'/fr/serie/harry-potter-hogwarts-tournament-of-houses/saison-1': 'V1',
	'/fr/serie/city-on-a-hill/saison-3': 'V2',
	'/fr/serie/genera-ion/saison-1': 'V3',
	'/fr/serie/baby-bandito/saison-2': 'V1',
	'/fr/serie/girls/saison-4': 'V2',
	'/fr/serie/bubulle-guppies/saison-1': 'V3',
	'/fr/serie/foyles-war/saison-3': 'V1',
	'/fr/serie/f1-the-academy/saison-1': 'V2',
	'/fr/serie/brokenwood/saison-6': 'V3',
	'/fr/serie/arifureta/saison-2': 'V1',
	'/fr/serie/chillin-in-another-world-with-level-2-super-cheat-powers/saison-1': 'V2',
	'/fr/serie/broad-city/saison-3': 'V3',
	'/fr/serie/bored-to-death/saison-1': 'V1',
	'/fr/serie/highlander/saison-4': 'V2',
	'/fr/serie/agent-k-c/saison-1': 'V3',
	'/fr/serie/are-you-human-too/saison-1': 'V1',
	'/fr/serie/dragons-par-dela-les-rives/saison-6': 'V2',
	'/fr/serie/bull-2016/saison-4': 'V3',
	'/fr/serie/chappelles-show/saison-1': 'V1',
	'/fr/serie/dora-lexploratrice/saison-1': 'V2',
	'/fr/serie/hello-tomorrow/saison-1': 'V3',
	'/fr/serie/ghost-adventures/saison-1': 'V1',
	'/fr/serie/hanna/saison-2': 'V2',
	'/fr/serie/dc-super-hero-girls/saison-2': 'V3',
	'/fr/serie/archer/saison-7': 'V1',
	'/fr/serie/channel-zero/saison-3': 'V2',
	'/fr/serie/grizzy-et-les-lemmings/saison-3': 'V3',
	'/fr/serie/cry-wolf/saison-1': 'V1',
	'/fr/serie/forensic-files/saison-11': 'V2',
	'/fr/serie/father-brown/saison-5': 'V3',
	'/fr/serie/dallas-1978/saison-7': 'V1',
	'/fr/serie/1992-mille-novecento-novantadue/saison-1': 'V2',
	'/fr/serie/alias/saison-5': 'V3',
	'/fr/serie/a-million-little-things/saison-1': 'V1',
	'/fr/serie/elena-davalor/saison-1': 'V2',
	'/fr/serie/chemistry-of-death/saison-1': 'V3',
	'/fr/serie/easy/saison-1': 'V1',
	'/fr/serie/bull-2016/saison-3': 'V2',
	'/fr/serie/full-metal-panic/saison-1': 'V3',
	'/fr/serie/candice-renoir/saison-8': 'V1',
	'/fr/serie/almost-paradise/saison-1': 'V2',
	'/fr/serie/catastrophe/saison-1': 'V3',
	'/fr/serie/bobs-burgers/saison-7': 'V1',
	'/fr/serie/alvinnn-et-les-chipmunks/saison-5': 'V2',
	'/fr/serie/air-disasters/saison-12': 'V3',
	'/fr/serie/crossing-lines/saison-2': 'V1',
	'/fr/serie/all-the-queens-men/saison-1': 'V2',
	'/fr/serie/berserk-of-gluttony/saison-1': 'V3',
	'/fr/serie/hudson-et-rex/saison-3': 'V1',
	'/fr/serie/alien-theory/saison-16': 'V2',
	'/fr/serie/dci-banks/saison-4': 'V3',
	'/fr/serie/exchange/saison-1': 'V1',
	'/fr/serie/bookie/saison-1': 'V2',
	'/fr/serie/blue-exorcist/saison-3': 'V3',
	'/fr/serie/archer/saison-6': 'V1',
	'/fr/serie/crimes-a-la-une/saison-8': 'V2',
	'/fr/serie/a-kind-of-spark/saison-1': 'V3',
	'/fr/serie/he-oua-oua/saison-3': 'V1',
	'/fr/serie/downhill-skiers/saison-1': 'V2',
	'/fr/serie/harpers-island/saison-1': 'V3',
	'/fr/serie/cucumber/saison-1': 'V1',
	'/fr/serie/higurashi-no-naku-koro-ni/saison-1': 'V2',
	'/fr/serie/cranford/saison-1': 'V3',
	'/fr/serie/batwoman/saison-2': 'V1',
	'/fr/serie/hantise/saison-2': 'V2',
	'/fr/serie/brickleberry/saison-1': 'V3',
	'/fr/serie/90-day-fiance-the-other-way/saison-1': 'V1',
	'/fr/serie/ersan-kuneri/saison-2': 'V2',
	'/fr/serie/forensic-files/saison-8': 'V3',
	'/fr/serie/a-couple-of-cuckoos/saison-1': 'V1',
	'/fr/serie/creepshow/saison-2': 'V2',
	'/fr/serie/bookie/saison-2': 'V3',
	'/fr/serie/boris/saison-4': 'V1',
	'/fr/serie/conversations-with-a-killer-the-ted-bundy-tapes/saison-1': 'V2',
	'/fr/serie/burn-notice/saison-3': 'V3',
	'/fr/serie/gangnam-b-side/saison-1': 'V1',
	'/fr/serie/doctor-who-1963/saison-2': 'V2',
	'/fr/serie/chloe/saison-1': 'V3',
	'/fr/serie/bob-leponge-lile-karate/saison-14': 'V1',
	'/fr/serie/deo-eiteu-syo/saison-1': 'V2',
	'/fr/serie/call-it-love/saison-1': 'V3',
	'/fr/serie/8-simple-rules/saison-2': 'V1',
	'/fr/serie/fate-grand-order-zettai-majuu-sensen-babylonia/saison-1': 'V2',
	'/fr/serie/all-american/saison-2': 'V3',
	'/fr/serie/dr-rose-au-coeur-des-urgences/saison-1': 'V1',
	'/fr/serie/burn-notice/saison-5': 'V2',
	'/fr/serie/comment-cest-fait/saison-1': 'V3',
	'/fr/serie/au-dela-du-reel-laventure-continue/saison-2': 'V1',
	'/fr/serie/icarly/saison-6': 'V2',
	'/fr/serie/five-days-at-memorial/saison-1': 'V3',
	'/fr/serie/drake-and-josh/saison-2': 'V1',
	'/fr/serie/a-confession/saison-1': 'V2',
	'/fr/serie/alvinnn-et-les-chipmunks/saison-2': 'V3',
	'/fr/serie/date-a-live/saison-1': 'V1',
	'/fr/serie/derek/saison-1': 'V2',
	'/fr/serie/cursed-la-rebelle/saison-1': 'V3',
	'/fr/serie/charmed/saison-7': 'V1',
	'/fr/serie/hwarang/saison-1': 'V2',
	'/fr/serie/apres-toi-le-chaos/saison-1': 'V3',
	'/fr/serie/deep-state/saison-1': 'V1',
	'/fr/serie/3/saison-4': 'V2',
	'/fr/serie/empire-playboy-les-dessous-meurtriers/saison-1': 'V3',
	'/fr/serie/full-house/saison-2': 'V1',
	'/fr/serie/badly-in-love/saison-1': 'V2',
	'/fr/serie/doctor-who-1963/saison-4': 'V3',
	'/fr/serie/being-human/saison-1': 'V1',
	'/fr/serie/alien-encounters-fact-or-fiction/saison-1': 'V2',
	'/fr/serie/gyeongseong-creature/saison-2': 'V3',
	'/fr/serie/assassination-classroom/saison-2': 'V1',
	'/fr/serie/alien-theory/saison-11': 'V2',
	'/fr/serie/in-treatment/saison-4': 'V3',
	'/fr/serie/hercule-poirot/saison-8': 'V1',
	'/fr/serie/beavis-and-butt-head/saison-1': 'V2',
	'/fr/serie/alerte-cobra/saison-1': 'V3',
	'/fr/serie/betty-la-fea-the-story-continues/saison-2': 'V1',
	'/fr/serie/beyond/saison-1': 'V2',
	'/fr/serie/catfish-fausse-identite/saison-9': 'V3',
	'/fr/serie/beyond-the-boundary/saison-1': 'V1',
	'/fr/serie/dear-hongrang/saison-1': 'V2',
	'/fr/serie/dragon-raja-the-blazing-dawn/saison-2': 'V3',
	'/fr/serie/evil-lives-here/saison-5': 'V1',
	'/fr/serie/divorce/saison-1': 'V2',
	'/fr/serie/hatufim-prisonniers-de-guerre/saison-1': 'V3',
	'/fr/serie/h2o-just-add-water/saison-2': 'V1',
	'/fr/serie/glitter-force-doki-doki/saison-1': 'V2',
	'/fr/serie/dime-tu-nombre/saison-1': 'V3',
	'/fr/serie/henry-danger/saison-3': 'V1',
	'/fr/serie/how-a-realist-hero-rebuilt-the-kingdom/saison-1': 'V2',
	'/fr/serie/cassandre/saison-7': 'V3',
	'/fr/serie/code-black/saison-2': 'V1',
	'/fr/serie/below-deck-mediterranean/saison-1': 'V2',
	'/fr/serie/bob-leponge-lile-karate/saison-10': 'V3',
	'/fr/serie/berlin-station/saison-2': 'V1',
	'/fr/serie/heartland/saison-16': 'V2',
	'/fr/serie/fated-to-love-you-2014/saison-1': 'V3',
	'/fr/serie/dead-pixels/saison-1': 'V1',
	'/fr/serie/catching-killers/saison-3': 'V2',
	'/fr/serie/aguila-roja/saison-4': 'V3',
	'/fr/serie/el-marginal/saison-2': 'V1',
	'/fr/serie/an-archdemons-dilemma-how-to-love-your-elf-bride/saison-1': 'V2',
	'/fr/serie/american-dad/saison-18': 'V3',
	'/fr/serie/american-dad/saison-2': 'V1',
	'/fr/serie/glee/saison-5': 'V2',
	'/fr/serie/bofuri-je-ne-suis-pas-venue-ici-pour-souffrir-alors-jai-tout-mis-en-defense/saison-1': 'V3',
	'/fr/serie/esprits-criminels-unite-sans-frontieres/saison-2': 'V1',
	'/fr/serie/dinosaur-king/saison-1': 'V2',
	'/fr/serie/anger-management/saison-1': 'V3',
	'/fr/serie/batman-la-releve/saison-3': 'V1',
	'/fr/serie/el-cuerpo-en-llamas/saison-1': 'V2',
	'/fr/serie/fais-pas-ci-fais-pas-ca/saison-1': 'V3',
	'/fr/serie/deutschland-83/saison-3': 'V1',
	'/fr/serie/code-breaker/saison-1': 'V2',
	'/fr/serie/class-of-07/saison-1': 'V3',
	'/fr/serie/homecoming/saison-2': 'V1',
	'/fr/serie/explained/saison-3': 'V2',
	'/fr/serie/digimon-adventure-2020/saison-1': 'V3',
	'/fr/serie/dci-banks/saison-5': 'V1',
	'/fr/serie/below-deck/saison-3': 'V2',
	'/fr/serie/drop-dead-diva/saison-5': 'V3',
	'/fr/serie/21-jump-street/saison-5': 'V1',
	'/fr/serie/dci-banks/saison-2': 'V2',
	'/fr/serie/doctor-who-1963/saison-5': 'V3',
	'/fr/serie/daria/saison-3': 'V1',
	'/fr/serie/desenchantee/saison-4': 'V2',
	'/fr/serie/42-dias-en-la-oscuridad/saison-1': 'V3',
	'/fr/serie/forensic-files/saison-7': 'V1',
	'/fr/serie/go-vive-a-tu-manera/saison-1': 'V2',
	'/fr/serie/amnesia-2004/saison-1': 'V3',
	'/fr/serie/hollywood-renove/saison-1': 'V1',
	'/fr/serie/be-cool-scooby-doo/saison-1': 'V2',
	'/fr/serie/change-days/saison-1': 'V3',
	'/fr/serie/30-rock/saison-6': 'V1',
	'/fr/serie/first-kill/saison-1': 'V2',
	'/fr/serie/icarly-revival/saison-1': 'V3',
	'/fr/serie/had-i-not-seen-the-sun/saison-2': 'V1',
	'/fr/serie/house-of-ninjas/saison-1': 'V2',
	'/fr/serie/hannah-montana/saison-2': 'V3',
	'/fr/serie/el-minuto-heroico-yo-tambien-deje-el-opus-dei/saison-1': 'V1',
	'/fr/serie/defiance/saison-3': 'V2',
	'/fr/serie/amphibia/saison-3': 'V3',
	'/fr/serie/im-a-noble-on-the-brink-of-ruin-so-i-might-as-well-try-mastering-magic/saison-1': 'V1',
	'/fr/serie/dollhouse/saison-1': 'V2',
	'/fr/serie/eureka/saison-3': 'V3',
	'/fr/serie/hokkaido-gals-are-super-adorable/saison-1': 'V1',
	'/fr/serie/amidst-a-snowstorm-of-love/saison-1': 'V2',
	'/fr/serie/betrothed-to-my-sisters-ex/saison-1': 'V3',
	'/fr/serie/ghost-whisperer/saison-4': 'V1',
	'/fr/serie/fais-moi-peur-1992/saison-1': 'V2',
	'/fr/serie/fatma/saison-1': 'V3',
	'/fr/serie/desenchantee/saison-3': 'V1',
	'/fr/serie/home-economics/saison-1': 'V2',
	'/fr/serie/hannah-montana/saison-3': 'V3',
	'/fr/serie/belfort-et-lupin/saison-1': 'V1',
	'/fr/serie/howards-end/saison-1': 'V2',
	'/fr/serie/cassandre/saison-1': 'V3',
	'/fr/serie/cherry-magic-thirty-years-of-virginity-can-make-you-a-wizard/saison-1': 'V1',
	'/fr/serie/a-very-british-scandal/saison-1': 'V2',
	'/fr/serie/90-day-fiance/saison-8': 'V3',
	'/fr/serie/antidisturbios/saison-1': 'V1',
	'/fr/serie/damages/saison-5': 'V2',
	'/fr/serie/dramaworld/saison-1': 'V3',
	'/fr/serie/claymore/saison-1': 'V1',
	'/fr/serie/according-to-jim/saison-7': 'V2',
	'/fr/serie/bottom/saison-2': 'V3',
	'/fr/serie/burn-notice/saison-4': 'V1',
	'/fr/serie/ashita-no-joe/saison-1': 'V2',
	'/fr/serie/hollywood-weapons/saison-5': 'V3',
	'/fr/serie/free/saison-1': 'V1',
	'/fr/serie/feel-good/saison-1': 'V2',
	'/fr/serie/anna/saison-1': 'V3',
	'/fr/serie/below-deck/saison-10': 'V1',
	'/fr/serie/ildan-ddeugeobge-ceongsohara/saison-1': 'V2',
	'/fr/serie/face-a-face/saison-3': 'V3',
	'/fr/serie/damages/saison-3': 'V1',
	'/fr/serie/all-hail-king-julien/saison-1': 'V2',
	'/fr/serie/a-body-in-the-snow-the-trial-of-karen-read/saison-1': 'V3',
	'/fr/serie/girls/saison-2': 'V1',
	'/fr/serie/alfred-hitchcock-presente/saison-5': 'V2',
	'/fr/serie/dennis-miller-live/saison-1': 'V3',
	'/fr/serie/cherif/saison-2': 'V1',
	'/fr/serie/hostel-daze/saison-4': 'V2',
	'/fr/serie/forensic-files/saison-6': 'V3',
	'/fr/serie/fena-pirate-princess/saison-1': 'V1',
	'/fr/serie/crashing-2017/saison-1': 'V2',
	'/fr/serie/dominion/saison-1': 'V3',
	'/fr/serie/blaze-and-the-monster-machines/saison-1': 'V1',
	'/fr/serie/hidden/saison-1': 'V2',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-14': 'V3',
	'/fr/serie/all-american-homecoming/saison-1': 'V1',
	'/fr/serie/city-on-fire/saison-1': 'V2',
	'/fr/serie/beyblade-metal-fusion/saison-3': 'V3',
	'/fr/serie/balcighage-gogo/saison-1': 'V1',
	'/fr/serie/empire/saison-1': 'V2',
	'/fr/serie/dudes-2025/saison-1': 'V3',
	'/fr/serie/clannad/saison-2': 'V1',
	'/fr/serie/a-korean-odyssey/saison-1': 'V2',
	'/fr/serie/equinox/saison-1': 'V3',
	'/fr/serie/familiar-wife/saison-1': 'V1',
	'/fr/serie/eungdabhara-1994/saison-1': 'V2',
	'/fr/serie/burn-notice/saison-2': 'V3',
	'/fr/serie/captain-tsubasa-olive-et-tom/saison-2': 'V1',
	'/fr/serie/gladiators/saison-1': 'V2',
	'/fr/serie/being-human-us/saison-4': 'V3',
	'/fr/serie/culdong-syupeowingseu/saison-2': 'V1',
	'/fr/serie/giant-beasts-of-ars/saison-1': 'V2',
	'/fr/serie/imma-tataranni-substitut-du-procureur/saison-1': 'V3',
	'/fr/serie/dragons-the-nine-realms/saison-3': 'V1',
	'/fr/serie/air-disasters/saison-5': 'V2',
	'/fr/serie/gang-war-pusher-street/saison-1': 'V3',
	'/fr/serie/docteur-la-peluche/saison-1': 'V1',
	'/fr/serie/blood-ties/saison-1': 'V2',
	'/fr/serie/faute-de-preuves/saison-1': 'V3',
	'/fr/serie/ben-10-2016/saison-1': 'V1',
	'/fr/serie/hercule/saison-1': 'V2',
	'/fr/serie/conflict/saison-1': 'V3',
	'/fr/serie/back-at-the-barnyard/saison-1': 'V1',
	'/fr/serie/harlots/saison-3': 'V2',
	'/fr/serie/carlos-rey-emperador/saison-1': 'V3',
	'/fr/serie/americas-book-of-secrets/saison-1': 'V1',
	'/fr/serie/bleach/saison-9': 'V2',
	'/fr/serie/air-disasters/saison-18': 'V3',
	'/fr/serie/he-oua-oua/saison-4': 'V1',
	'/fr/serie/below-deck/saison-6': 'V2',
	'/fr/serie/american-monster/saison-6': 'V3',
	'/fr/serie/creepshow/saison-3': 'V1',
	'/fr/serie/franklin-and-bash/saison-4': 'V2',
	'/fr/serie/devil-in-ohio/saison-1': 'V3',
	'/fr/serie/catching-killers/saison-2': 'V1',
	'/fr/serie/detective-conan/saison-3': 'V2',
	'/fr/serie/grand-blue/saison-1': 'V3',
	'/fr/serie/inazuma-eleven/saison-2': 'V1',
	'/fr/serie/below-deck-adventure/saison-1': 'V2',
	'/fr/serie/big-timber/saison-2': 'V3',
	'/fr/serie/anime-monster-strike-deadverse-reloaded/saison-1': 'V1',
	'/fr/serie/abstract-the-art-of-design/saison-1': 'V2',
	'/fr/serie/amour-entre-la-fee-et-le-diable/saison-1': 'V3',
	'/fr/serie/damages/saison-4': 'V1',
	'/fr/serie/honey-lemon-soda/saison-1': 'V2',
	'/fr/serie/daniel-tigers-neighborhood/saison-2': 'V3',
	'/fr/serie/flight-of-the-conchords/saison-2': 'V1',
	'/fr/serie/air-disasters/saison-2': 'V2',
	'/fr/serie/arde-madrid/saison-1': 'V3',
	'/fr/serie/foyles-war/saison-5': 'V1',
	'/fr/serie/blues-clues-and-you/saison-1': 'V2',
	'/fr/serie/air-force-one-ne-repond-plus/saison-1': 'V3',
	'/fr/serie/below-deck-sailing-yacht/saison-3': 'V1',
	'/fr/serie/avengers-lequipe-des-super-heros/saison-1': 'V2',
	'/fr/serie/air-disasters/saison-11': 'V3',
	'/fr/serie/as-the-crow-flies/saison-1': 'V1',
	'/fr/serie/gantz/saison-2': 'V2',
	'/fr/serie/henry-danger/saison-2': 'V3',
	'/fr/serie/cosmos-nouveaux-mondes/saison-1': 'V1',
	'/fr/serie/forensic-files/saison-5': 'V2',
	'/fr/serie/an-idiot-abroad/saison-3': 'V3',
	'/fr/serie/family-business/saison-1': 'V1',
	'/fr/serie/flcl/saison-2': 'V2',
	'/fr/serie/dancing-on-the-edge/saison-1': 'V3',
	'/fr/serie/holy-faak/saison-1': 'V1',
	'/fr/serie/air-disasters/saison-10': 'V2',
	'/fr/serie/central-park/saison-1': 'V3',
	'/fr/serie/crooks/saison-1': 'V1',
	'/fr/serie/el-tiempo-que-te-doy/saison-1': 'V2',
	'/fr/serie/giri-haji/saison-1': 'V3',
	'/fr/serie/back-to-life/saison-2': 'V1',
	'/fr/serie/hitori-no-shita-the-outcast/saison-6': 'V2',
	'/fr/serie/deadwind/saison-2': 'V3',
	'/fr/serie/daybreak/saison-1': 'V1',
	'/fr/serie/forensic-files/saison-9': 'V2',
	'/fr/serie/candice-renoir/saison-11': 'V3',
	'/fr/serie/anthony-bourdain-no-reservations/saison-5': 'V1',
	'/fr/serie/attack-on-london-hunting-the-7-7-bombers/saison-1': 'V2',
	'/fr/serie/chesapeake-shores/saison-6': 'V3',
	'/fr/serie/enlightened/saison-1': 'V1',
	'/fr/serie/au-service-de-la-france/saison-1': 'V2',
	'/fr/serie/big-time-rush/saison-4': 'V3',
	'/fr/serie/beat/saison-1': 'V1',
	'/fr/serie/apocalypse-la-deuxieme-guerre-mondiale/saison-2': 'V2',
	'/fr/serie/digimon-adventure-tri/saison-1': 'V3',
	'/fr/serie/endangered-planet/saison-1': 'V1',
	'/fr/serie/entourage/saison-5': 'V2',
	'/fr/serie/below-deck-sailing-yacht/saison-5': 'V3',
	'/fr/serie/black-butler/saison-3': 'V1',
	'/fr/serie/baby/saison-2': 'V2',
	'/fr/serie/heartland/saison-15': 'V3',
	'/fr/serie/american-murder-gabby-petito/saison-1': 'V1',
	'/fr/serie/el-chema/saison-1': 'V2',
	'/fr/serie/a-terrified-teacher-at-ghoul-school/saison-1': 'V3',
	'/fr/serie/dna/saison-2': 'V1',
	'/fr/serie/in-the-soop-bts-ver/saison-1': 'V2',
	'/fr/serie/close-enough/saison-1': 'V3',
	'/fr/serie/gargantia-on-the-verdurous-planet/saison-1': 'V1',
	'/fr/serie/full-house/saison-7': 'V2',
	'/fr/serie/alex-hugo/saison-3': 'V3',
	'/fr/serie/drifters/saison-1': 'V1',
	'/fr/serie/chasseurs-de-trolls/saison-2': 'V2',
	'/fr/serie/city-the-animation/saison-1': 'V3',
	'/fr/serie/fate-strange-fake-whispers-of-dawn/saison-1': 'V1',
	'/fr/serie/animals/saison-1': 'V2',
	'/fr/serie/black-butler/saison-2': 'V3',
	'/fr/serie/as-we-see-it/saison-1': 'V1',
	'/fr/serie/gordon-ramsay-bataille-de-chefs/saison-3': 'V2',
	'/fr/serie/friends-from-college/saison-1': 'V3',
	'/fr/serie/dragon-sakura-s2/saison-1': 'V1',
	'/fr/serie/cidade-invisivel/saison-1': 'V2',
	'/fr/serie/entrevias/saison-2': 'V3',
	'/fr/serie/foods-greatest-hits/saison-1': 'V1',
	'/fr/serie/boy-meets-world/saison-6': 'V2',
	'/fr/serie/dragons-par-dela-les-rives/saison-4': 'V3',
	'/fr/serie/below-deck/saison-7': 'V1',
	'/fr/serie/girls5eva/saison-2': 'V2',
	'/fr/serie/geordie-shore/saison-25': 'V3',
	'/fr/serie/a-couple-of-cuckoos/saison-2': 'V1',
	'/fr/serie/clark/saison-1': 'V2',
	'/fr/serie/black-butler/saison-4': 'V3',
	'/fr/serie/foyles-war/saison-6': 'V1',
	'/fr/serie/geunyeoneun-geojismaleul-neomu-saranghae/saison-1': 'V2',
	'/fr/serie/ghost-adventures/saison-25': 'V3',
	'/fr/serie/air-disasters/saison-16': 'V1',
	'/fr/serie/go-diego-go/saison-1': 'V2',
	'/fr/serie/better-things/saison-5': 'V3',
	'/fr/serie/chicago-justice/saison-1': 'V1',
	'/fr/serie/dci-banks/saison-3': 'V2',
	'/fr/serie/ally-mcbeal/saison-5': 'V3',
	'/fr/serie/1992/saison-1': 'V1',
	'/fr/serie/cinq-jours/saison-2': 'V2',
	'/fr/serie/a-small-light/saison-1': 'V3',
	'/fr/serie/boris/saison-3': 'V1',
	'/fr/serie/in-the-dark/saison-1': 'V2',
	'/fr/serie/exterminate-all-the-brutes/saison-1': 'V3',
	'/fr/serie/american-monster/saison-12': 'V1',
	'/fr/serie/gremlins-secrets-of-the-mogwai/saison-2': 'V2',
	'/fr/serie/are-you-the-one/saison-8': 'V3',
	'/fr/serie/hoarders/saison-1': 'V1',
	'/fr/serie/alice-nevers-le-juge-est-une-femme/saison-5': 'V2',
	'/fr/serie/cardinal/saison-4': 'V3',
	'/fr/serie/elena-davalor/saison-3': 'V1',
	'/fr/serie/after-school-hanako-kun/saison-1': 'V2',
	'/fr/serie/anthony-bourdain-no-reservations/saison-3': 'V3',
	'/fr/serie/brothers-and-sisters/saison-4': 'V1',
	'/fr/serie/incorporated/saison-1': 'V2',
	'/fr/serie/dave/saison-1': 'V3',
	'/fr/serie/amy-bradley-is-missing/saison-1': 'V1',
	'/fr/serie/destinations-of-the-damned-with-zak-bagans/saison-1': 'V2',
	'/fr/serie/dosinamnyeoyi-sarangbeob/saison-1': 'V3',
	'/fr/serie/icarly-revival/saison-3': 'V1',
	'/fr/serie/captivating-the-king/saison-1': 'V2',
	'/fr/serie/homicide-hours-to-kill/saison-2': 'V3',
	'/fr/serie/danganronpa-3-la-fin-de-lacademie-kibogamine-desespoir/saison-1': 'V1',
	'/fr/serie/baahubali-the-lost-legends/saison-3': 'V2',
	'/fr/serie/1001-vraies-pattes/saison-2': 'V3',
	'/fr/serie/alvinnn-et-les-chipmunks/saison-4': 'V1',
	'/fr/serie/fais-moi-peur/saison-2': 'V2',
	'/fr/serie/bia/saison-2': 'V3',
	'/fr/serie/breathe/saison-1': 'V1',
	'/fr/serie/huset/saison-1': 'V2',
	'/fr/serie/below-deck-mediterranean/saison-6': 'V3',
	'/fr/serie/braquo/saison-1': 'V1',
	'/fr/serie/ceongcunsidae/saison-1': 'V2',
	'/fr/serie/home-before-dark/saison-1': 'V3',
	'/fr/serie/explained/saison-1': 'V1',
	'/fr/serie/daily-dose-of-sunshine/saison-1': 'V2',
	'/fr/serie/alerte-a-malibu/saison-10': 'V3',
	'/fr/serie/family-business/saison-2': 'V1',
	'/fr/serie/hero-inside/saison-1': 'V2',
	'/fr/serie/expedition-x/saison-6': 'V3',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-8': 'V1',
	'/fr/serie/bitten/saison-3': 'V2',
	'/fr/serie/born-again/saison-1': 'V3',
	'/fr/serie/angels-in-america/saison-1': 'V1',
	'/fr/serie/fit-for-tv-the-reality-of-the-biggest-loser/saison-1': 'V2',
	'/fr/serie/autumn-in-my-heart/saison-1': 'V3',
	'/fr/serie/being-human/saison-4': 'V1',
	'/fr/serie/a-bit-of-fry-and-laurie/saison-2': 'V2',
	'/fr/serie/dora-lexploratrice/saison-2': 'V3',
	'/fr/serie/broad-city/saison-4': 'V1',
	'/fr/serie/im-getting-married-to-a-girl-i-hate-in-my-class/saison-1': 'V2',
	'/fr/serie/gyeolhongyeyag/saison-1': 'V3',
	'/fr/serie/betty-en-ny/saison-1': 'V1',
	'/fr/serie/assassinats-politiques/saison-1': 'V2',
	'/fr/serie/el-silencio/saison-1': 'V3',
	'/fr/serie/below-deck/saison-5': 'V1',
	'/fr/serie/en-flagrant-delit/saison-1': 'V2',
	'/fr/serie/anthony-bourdain-no-reservations/saison-4': 'V3',
	'/fr/serie/49-days/saison-1': 'V1',
	'/fr/serie/eva-luna/saison-1': 'V2',
	'/fr/serie/adhuuraa/saison-1': 'V3',
	'/fr/serie/broad-city/saison-5': 'V1',
	'/fr/serie/1992-mille-novecento-novantadue/saison-3': 'V2',
	'/fr/serie/heroes-reborn/saison-1': 'V3',
	'/fr/serie/divorce/saison-2': 'V1',
	'/fr/serie/being-erica/saison-1': 'V2',
	'/fr/serie/flipping-bangers/saison-1': 'V3',
	'/fr/serie/as-the-crow-flies/saison-2': 'V1',
	'/fr/serie/ballmastrz-9009/saison-1': 'V2',
	'/fr/serie/bad-girls-club/saison-1': 'V3',
	'/fr/serie/glamorous-temptation/saison-1': 'V1',
	'/fr/serie/doctor-elise-the-royal-lady-with-the-lamp/saison-1': 'V2',
	'/fr/serie/class-2022/saison-1': 'V3',
	'/fr/serie/dinner-mate/saison-1': 'V1',
	'/fr/serie/bao-zhuan-shiyuto-beiburedo/saison-3': 'V2',
	'/fr/serie/full-house/saison-3': 'V3',
	'/fr/serie/a-killer-paradox/saison-1': 'V1',
	'/fr/serie/disco-soundtrack-of-a-revolution/saison-1': 'V2',
	'/fr/serie/delete-me/saison-1': 'V3',
	'/fr/serie/a-travers-les-tenebres/saison-1': 'V1',
	'/fr/serie/cold-case-who-killed-jonbenet-ramsey/saison-1': 'V2',
	'/fr/serie/air-disasters/saison-3': 'V3',
	'/fr/serie/everything-now/saison-1': 'V1',
	'/fr/serie/her-voice/saison-1': 'V2',
	'/fr/serie/air-disasters/saison-15': 'V3',
	'/fr/serie/bien-dans-son-assiette-la-preuve-par-deux/saison-1': 'V1',
	'/fr/serie/five-came-back-the-reference-films/saison-1': 'V2',
	'/fr/serie/bajo-sospecha/saison-1': 'V3',
	'/fr/serie/dollface/saison-1': 'V1',
	'/fr/serie/docteur-quinn-femme-medecin/saison-5': 'V2',
	'/fr/serie/chesapeake-shores/saison-3': 'V3',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-9': 'V1',
	'/fr/serie/fais-moi-peur/saison-1': 'V2',
	'/fr/serie/eoneu-nal-uri-jib-hyeongwaeuro-myeolmangyi-deuleowassda/saison-1': 'V3',
	'/fr/serie/bottom/saison-1': 'V1',
	'/fr/serie/big-nate/saison-2': 'V2',
	'/fr/serie/bakugan-battle-planet/saison-1': 'V3',
	'/fr/serie/alexander-the-making-of-a-god/saison-1': 'V1',
	'/fr/serie/borgia/saison-2': 'V2',
	'/fr/serie/cosita-linda/saison-1': 'V3',
	'/fr/serie/doctor-who-1963/saison-18': 'V1',
	'/fr/serie/cocaine-quarterback-signal-caller-for-the-cartel/saison-1': 'V2',
	'/fr/serie/blunt-talk/saison-1': 'V3',
	'/fr/serie/erreurs-de-construction/saison-1': 'V1',
	'/fr/serie/granblue-fantasy-the-animation/saison-2': 'V2',
	'/fr/serie/ballroom-e-youkoso/saison-1': 'V3',
	'/fr/serie/according-to-jim/saison-2': 'V1',
	'/fr/serie/dear-sa-chan/saison-1': 'V2',
	'/fr/serie/bir-baskadir/saison-1': 'V3',
	'/fr/serie/blues-clues/saison-1': 'V1',
	'/fr/serie/euracaca-waikiki/saison-2': 'V2',
	'/fr/serie/beyblade-burst/saison-7': 'V3',
	'/fr/serie/hap-and-leonard/saison-3': 'V1',
	'/fr/serie/ghostwriter/saison-1': 'V2',
	'/fr/serie/apple-and-onion/saison-2': 'V3',
	'/fr/serie/army-wives/saison-1': 'V1',
	'/fr/serie/house-of-hammer/saison-1': 'V2',
	'/fr/serie/bloody-game/saison-1': 'V3',
	'/fr/serie/aqua-teen-hunger-force/saison-1': 'V1',
	'/fr/serie/harlem/saison-1': 'V2',
	'/fr/serie/down-to-earth-with-zac-efron/saison-2': 'V3',
	'/fr/serie/alex-hugo/saison-5': 'V1',
	'/fr/serie/breath-of-fire/saison-1': 'V2',
	'/fr/serie/fearless-2017/saison-1': 'V3',
	'/fr/serie/empresses-in-the-palace/saison-1': 'V1',
	'/fr/serie/family-business/saison-3': 'V2',
	'/fr/serie/blindspotting/saison-1': 'V3',
	'/fr/serie/devil-in-the-family-the-fall-of-ruby-franke/saison-1': 'V1',
	'/fr/serie/balthazar/saison-5': 'V2',
	'/fr/serie/fi/saison-2': 'V3',
	'/fr/serie/cauchemar-sur-lautoroute/saison-1': 'V1',
	'/fr/serie/ga-doo-ris-sushi-restaurant/saison-1': 'V2',
	'/fr/serie/happy-sugar-life/saison-1': 'V3',
	'/fr/serie/in-my-skin/saison-2': 'V1',
	'/fr/serie/chasseurs-de-dragons/saison-1': 'V2',
	'/fr/serie/black-lightning/saison-3': 'V3',
	'/fr/serie/dr-pimple-popper/saison-5': 'V1',
	'/fr/serie/gakuen-babysitters/saison-1': 'V2',
	'/fr/serie/bunkd/saison-1': 'V3',
	'/fr/serie/catfish-fausse-identite/saison-8': 'V1',
	'/fr/serie/cassandre/saison-4': 'V2',
	'/fr/serie/doctor-who-1963/saison-24': 'V3',
	'/fr/serie/a-bloody-lucky-day/saison-1': 'V1',
	'/fr/serie/caillou/saison-1': 'V2',
	'/fr/serie/f-is-for-family/saison-3': 'V3',
	'/fr/serie/au-pair/saison-1': 'V1',
	'/fr/serie/conversations-with-a-killer-the-son-of-sam-tapes/saison-1': 'V2',
	'/fr/serie/a-certain-magical-index/saison-2': 'V3',
	'/fr/serie/batwheels/saison-2': 'V1',
	'/fr/serie/glamorous/saison-1': 'V2',
	'/fr/serie/bat-masterson/saison-1': 'V3',
	'/fr/serie/god-eater/saison-1': 'V1',
	'/fr/serie/home-adventures-with-tip-and-oh/saison-1': 'V2',
	'/fr/serie/climax/saison-1': 'V3',
	'/fr/serie/american-detective-with-lt-joe-kenda/saison-1': 'V1',
	'/fr/serie/hiiro-no-kakera/saison-1': 'V2',
	'/fr/serie/evil-lives-here-shadows-of-death/saison-3': 'V3',
	'/fr/serie/fate-extra-last-encore/saison-1': 'V1',
	'/fr/serie/clique/saison-2': 'V2',
	'/fr/serie/brickleberry/saison-3': 'V3',
	'/fr/serie/clusterf-k-woodstock-99/saison-1': 'V1',
	'/fr/serie/aldnoah-zero/saison-1': 'V2',
	'/fr/serie/batwheels/saison-1': 'V3',
	'/fr/serie/how-to-ruin-love/saison-2': 'V1',
	'/fr/serie/all-the-flowers/saison-1': 'V2',
	'/fr/serie/another-miss-oh/saison-1': 'V3',
	'/fr/serie/extinct-or-alive/saison-1': 'V1',
	'/fr/serie/fosse-verdon/saison-1': 'V2',
	'/fr/serie/broad-city/saison-2': 'V3',
	'/fr/serie/dokyuu-hentai-hxeros/saison-1': 'V1',
	'/fr/serie/grease-rise-of-the-pink-ladies/saison-1': 'V2',
	'/fr/serie/good-trouble/saison-2': 'V3',
	'/fr/serie/chastity-high/saison-1': 'V1',
	'/fr/serie/desenchantee/saison-2': 'V2',
	'/fr/serie/alerte-cobra/saison-2': 'V3',
	'/fr/serie/alice-nevers-le-juge-est-une-femme/saison-6': 'V1',
	'/fr/serie/full-custom-garage/saison-8': 'V2',
	'/fr/serie/hatufim-prisonniers-de-guerre/saison-2': 'V3',
	'/fr/serie/estonia-a-find-that-changes-everything/saison-1': 'V1',
	'/fr/serie/dicte/saison-3': 'V2',
	'/fr/serie/damnation/saison-1': 'V3',
	'/fr/serie/furia/saison-2': 'V1',
	'/fr/serie/comment-cest-fait/saison-9': 'V2',
	'/fr/serie/fireflies/saison-1': 'V3',
	'/fr/serie/blood-and-treasure/saison-2': 'V1',
	'/fr/serie/femme-fatales/saison-1': 'V2',
	'/fr/serie/16-and-pregnant/saison-1': 'V3',
	'/fr/serie/ever-after-high/saison-4': 'V1',
	'/fr/serie/ambulance/saison-5': 'V2',
	'/fr/serie/aggretsuko/saison-5': 'V3',
	'/fr/serie/bajo-sospecha/saison-2': 'V1',
	'/fr/serie/blues-clues-and-you/saison-4': 'V2',
	'/fr/serie/american-detective-with-lt-joe-kenda/saison-2': 'V3',
	'/fr/serie/arangsaddojeon/saison-1': 'V1',
	'/fr/serie/gigolo-per-caso/saison-1': 'V2',
	'/fr/serie/dna/saison-1': 'V3',
	'/fr/serie/au-dela-du-reel-laventure-continue/saison-6': 'V1',
	'/fr/serie/ferry-de-serie/saison-1': 'V2',
	'/fr/serie/elite-short-stories-carla-samuel/saison-1': 'V3',
	'/fr/serie/facing-kate/saison-1': 'V1',
	'/fr/serie/how-to-change-your-mind/saison-1': 'V2',
	'/fr/serie/il-commissario-montalbano/saison-2': 'V3',
	'/fr/serie/frequency/saison-1': 'V1',
	'/fr/serie/di4ri/saison-2': 'V2',
	'/fr/serie/cain/saison-4': 'V3',
	'/fr/serie/hache/saison-2': 'V1',
	'/fr/serie/containment/saison-1': 'V2',
	'/fr/serie/dynasty-2017/saison-3': 'V3',
	'/fr/serie/adult-material/saison-1': 'V1',
	'/fr/serie/dragons-par-dela-les-rives/saison-3': 'V2',
	'/fr/serie/charles-sen-charge/saison-1': 'V3',
	'/fr/serie/air-disasters/saison-13': 'V1',
	'/fr/serie/car-s-o-s/saison-10': 'V2',
	'/fr/serie/doubt-2024/saison-1': 'V3',
	'/fr/serie/immature/saison-1': 'V1',
	'/fr/serie/alaska-la-ruee-vers-lor/saison-3': 'V2',
	'/fr/serie/black-jesus/saison-1': 'V3',
	'/fr/serie/disneys-adventures-of-the-gummi-bears/saison-1': 'V1',
	'/fr/serie/falsa-identidad/saison-1': 'V2',
	'/fr/serie/apache-la-vida-de-carlos-tevez/saison-1': 'V3',
	'/fr/serie/au-dela-du-reel-laventure-continue/saison-4': 'V1',
	'/fr/serie/fast-n-loud/saison-2': 'V2',
	'/fr/serie/ibeon-ju-anaega-barameul-pibnida/saison-1': 'V3',
	'/fr/serie/hackadoll-the-animation/saison-1': 'V1',
	'/fr/serie/dragons-par-dela-les-rives/saison-2': 'V2',
	'/fr/serie/highlander/saison-5': 'V3',
	'/fr/serie/huff/saison-1': 'V1',
	'/fr/serie/200-dollars-plus-les-frais/saison-5': 'V2',
	'/fr/serie/how-the-universe-works/saison-5': 'V3',
	'/fr/serie/an-idiot-abroad/saison-2': 'V1',
	'/fr/serie/in-the-dark/saison-4': 'V2',
	'/fr/serie/bitten/saison-2': 'V3',
	'/fr/serie/barbie-dreamhouse-adventures/saison-1': 'V1',
	'/fr/serie/deux-guerres-une-histoire/saison-1': 'V2',
	'/fr/serie/dallas/saison-1': 'V3',
	'/fr/serie/elven-la-riviere-des-secrets/saison-1': 'V1',
	'/fr/serie/caught-on-bodycam/saison-1': 'V2',
	'/fr/serie/avengers-rassemblement/saison-3': 'V3',
	'/fr/serie/hero-inside/saison-2': 'V1',
	'/fr/serie/100-dias-para-enamorarnos/saison-1': 'V2',
	'/fr/serie/canaan/saison-1': 'V3',
	'/fr/serie/abby-hatcher/saison-1': 'V1',
	'/fr/serie/car-masters-de-la-rouille-a-lor/saison-5': 'V2',
	'/fr/serie/in-the-dark/saison-2': 'V3',
	'/fr/serie/90210-beverly-hills-nouvelle-generation/saison-3': 'V1',
	'/fr/serie/dupur-thakurpo/saison-1': 'V2',
	'/fr/serie/aux-origines/saison-1': 'V3',
	'/fr/serie/buried-in-the-backyard/saison-4': 'V1',
	'/fr/serie/cabanes-perchees/saison-11': 'V2',
	'/fr/serie/gutsudonaitowarudo/saison-1': 'V3',
	'/fr/serie/absolutely-fabulous/saison-5': 'V1',
	'/fr/serie/bad-girls-club/saison-11': 'V2',
	'/fr/serie/buried-in-the-backyard/saison-5': 'V3',
	'/fr/serie/evermoor/saison-1': 'V1',
	'/fr/serie/au-dela-du-reel-laventure-continue/saison-5': 'V2',
	'/fr/serie/grenseland/saison-1': 'V3',
	'/fr/serie/deep-state/saison-2': 'V1',
	'/fr/serie/gunju-gamyeonyi-juin/saison-1': 'V2',
	'/fr/serie/dallas-cowboys-cheerleaders-making-the-team/saison-1': 'V3',
	'/fr/serie/american-crime/saison-2': 'V1',
	'/fr/serie/i-am-georgina/saison-3': 'V2',
	'/fr/serie/a-galaxy-next-door/saison-1': 'V3',
	'/fr/serie/ainori/saison-1': 'V1',
	'/fr/serie/devious-maids/saison-4': 'V2',
	'/fr/serie/amudo-eobsneun-supsokeseo/saison-1': 'V3',
	'/fr/serie/ex-wives-of-rock/saison-1': 'V1',
	'/fr/serie/dead-mount-death-play/saison-1': 'V2',
	'/fr/serie/hunting-a-monster/saison-1': 'V3',
	'/fr/serie/air-disasters/saison-17': 'V1',
	'/fr/serie/culte/saison-1': 'V2',
	'/fr/serie/aho-girl/saison-1': 'V3',
	'/fr/serie/beyblade-burst/saison-4': 'V1',
	'/fr/serie/how-to-get-rich/saison-1': 'V2',
	'/fr/serie/date-a-live/saison-2': 'V3',
	'/fr/serie/blippi-wonders/saison-1': 'V1',
	'/fr/serie/a-certain-magical-index/saison-3': 'V2',
	'/fr/serie/absolutely-fabulous/saison-6': 'V3',
	'/fr/serie/culdong-syupeowingseu/saison-7': 'V1',
	'/fr/serie/comyeone-saranghabnida/saison-1': 'V2',
	'/fr/serie/crimes-that-shook-australia/saison-3': 'V3',
	'/fr/serie/ghost/saison-1': 'V1',
	'/fr/serie/increditales/saison-1': 'V2',
	'/fr/serie/donde-esta-marta/saison-1': 'V3',
	'/fr/serie/der-fall-jens-soring-todliche-leidenschaft/saison-1': 'V1',
	'/fr/serie/dream-high/saison-1': 'V2',
	'/fr/serie/chihayafuru/saison-2': 'V3',
	'/fr/serie/american-chopper/saison-1': 'V1',
	'/fr/serie/higurashi-no-naku-koro-ni/saison-2': 'V2',
	'/fr/serie/gigantosaurus/saison-1': 'V3',
	'/fr/serie/abby-hatcher/saison-2': 'V1',
	'/fr/serie/allen-v-farrow/saison-1': 'V2',
	'/fr/serie/bad-girls-club/saison-10': 'V3',
	'/fr/serie/alex-hugo/saison-4': 'V1',
	'/fr/serie/el-dragon/saison-1': 'V2',
	'/fr/serie/dead-of-night-2018/saison-1': 'V3',
	'/fr/serie/crossfire/saison-1': 'V1',
	'/fr/serie/braquo/saison-2': 'V2',
	'/fr/serie/cabanes-perchees/saison-1': 'V3',
	'/fr/serie/bugs-bunny-builders/saison-1': 'V1',
	'/fr/serie/drive-2013/saison-5': 'V2',
	'/fr/serie/danny-will-die-alone/saison-1': 'V3',
	'/fr/serie/germany-shore/saison-1': 'V1',
	'/fr/serie/hai-to-gensou-no-grimgar/saison-1': 'V2',
	'/fr/serie/conan-le-conquerant/saison-1': 'V3',
	'/fr/serie/cinderella-game/saison-1': 'V1',
	'/fr/serie/alerte-cobra/saison-3': 'V2',
	'/fr/serie/44-gatti/saison-1': 'V3',
	'/fr/serie/dear-white-people/saison-4': 'V1',
	'/fr/serie/hostages-il/saison-1': 'V2',
	'/fr/serie/alerte-a-malibu/saison-5': 'V3',
	'/fr/serie/greenhouse-academy/saison-1': 'V1',
	'/fr/serie/degrassi-next-class/saison-1': 'V2',
	'/fr/serie/divorce/saison-3': 'V3',
	'/fr/serie/an-update-on-our-family/saison-1': 'V1',
	'/fr/serie/flames/saison-2': 'V2',
	'/fr/serie/im-in-love-with-the-villainess/saison-1': 'V3',
	'/fr/serie/cabanes-perchees/saison-6': 'V1',
	'/fr/serie/aianman/saison-1': 'V2',
	'/fr/serie/buba/saison-2': 'V3',
	'/fr/serie/dr-seusss-red-fish-blue-fish/saison-2': 'V1',
	'/fr/serie/hush-hush/saison-1': 'V2',
	'/fr/serie/bake-squad/saison-2': 'V3',
	'/fr/serie/doctor-thorne/saison-1': 'V1',
	'/fr/serie/barbie-life-in-the-dreamhouse/saison-1': 'V2',
	'/fr/serie/gold-et-greed-the-hunt-for-fenns-treasure/saison-1': 'V3',
	'/fr/serie/impossible-peace/saison-1': 'V1',
	'/fr/serie/ghost-force/saison-1': 'V2',
	'/fr/serie/bad-blood/saison-2': 'V3',
	'/fr/serie/ekaterina/saison-2': 'V1',
	'/fr/serie/catfish-fausse-identite/saison-7': 'V2',
	'/fr/serie/ainori-love-wagon-african-journey/saison-1': 'V3',
	'/fr/serie/buried-in-the-backyard/saison-2': 'V1',
	'/fr/serie/buried-in-the-backyard/saison-3': 'V2',
	'/fr/serie/fear-thy-neighbor/saison-4': 'V3',
	'/fr/serie/australie-la-ruee-vers-lor/saison-1': 'V1',
	'/fr/serie/big-block-singsong/saison-1': 'V2',
	'/fr/serie/el-presidente/saison-1': 'V3',
	'/fr/serie/higewoti-ru-soshitenu-zi-gao-sheng-woshi-u/saison-1': 'V1',
	'/fr/serie/gangsters-les-diables-de-lamerique/saison-2': 'V2',
	'/fr/serie/canto-para-no-llorar-arelys-henao/saison-1': 'V3',
	'/fr/serie/alerte-cobra/saison-4': 'V1',
	'/fr/serie/iliza-shlesinger-a-different-animal/saison-1': 'V2',
	'/fr/serie/dream-on/saison-1': 'V3',
	'/fr/serie/american-monster/saison-7': 'V1',
	'/fr/serie/best-mistake/saison-1': 'V2',
	'/fr/serie/el-leba/saison-1': 'V3',
	'/fr/serie/bortfort/saison-1': 'V1',
	'/fr/serie/fancy-nancy/saison-1': 'V2',
	'/fr/serie/a-linstinct/saison-1': 'V3',
	'/fr/serie/game-shakers/saison-3': 'V1',
	'/fr/serie/australia-zoo-le-defi-des-irwin/saison-1': 'V2',
	'/fr/serie/great-escapes-with-morgan-freeman/saison-1': 'V3',
	'/fr/serie/elena-davalor/saison-2': 'V1',
	'/fr/serie/gunman-in-joseon/saison-1': 'V2',
	'/fr/serie/cocaine-air-smugglers-at-30-000-ft/saison-1': 'V3',
	'/fr/serie/hotelier/saison-1': 'V1',
	'/fr/serie/greenleaf/saison-2': 'V2',
	'/fr/serie/dr-pimple-popper/saison-1': 'V3',
	'/fr/serie/doctor-who-1963/saison-11': 'V1',
	'/fr/serie/chercheurs-dopale/saison-3': 'V2',
	'/fr/serie/dollhouse/saison-2': 'V3',
	'/fr/serie/chrisley-knows-best/saison-10': 'V1',
	'/fr/serie/belle-et-sebastien-2017/saison-1': 'V2',
	'/fr/serie/conversations-with-a-killer-the-jeffrey-dahmer-tapes/saison-1': 'V3',
	'/fr/serie/alta-mar/saison-3': 'V1',
	'/fr/serie/ano-natsu-de-matteru/saison-1': 'V2',
	'/fr/serie/100-loup-la-legende-de-la-pierre-de-lune/saison-1': 'V3',
	'/fr/serie/club-de-cuervos/saison-1': 'V1',
	'/fr/serie/bloodride/saison-1': 'V2',
	'/fr/serie/brothers-and-sisters/saison-3': 'V3',
	'/fr/serie/crisis-in-six-scenes/saison-1': 'V1',
	'/fr/serie/bad-girls-club/saison-2': 'V2',
	'/fr/serie/dodosolsolrarasol/saison-1': 'V3',
	'/fr/serie/bebefinn/saison-1': 'V1',
	'/fr/serie/change-days/saison-2': 'V2',
	'/fr/serie/inazuma-eleven-go/saison-1': 'V3',
	'/fr/serie/go-buster/saison-1': 'V1',
	'/fr/serie/doctor-lawyer/saison-1': 'V2',
	'/fr/serie/frida-kahlo/saison-1': 'V3',
	'/fr/serie/7-a-la-maison/saison-2': 'V1',
	'/fr/serie/hitoshi-matsumoto-presents-dokiyumentaru/saison-2': 'V2',
	'/fr/serie/al-asouf/saison-1': 'V3',
	'/fr/serie/go-jetters/saison-1': 'V1',
	'/fr/serie/follow-the-money/saison-3': 'V2',
	'/fr/serie/de-lombre-a-la-lumiere/saison-1': 'V3',
	'/fr/serie/galactik-footbal/saison-3': 'V1',
	'/fr/serie/ghost-hunters/saison-1': 'V2',
	'/fr/serie/bering-sea-gold/saison-15': 'V3',
	'/fr/serie/beyblade-burst/saison-6': 'V1',
	'/fr/serie/ensemble-stars/saison-1': 'V2',
	'/fr/serie/cabanes-perchees/saison-4': 'V3',
	'/fr/serie/braquo/saison-4': 'V1',
	'/fr/serie/bojwagwan-sesangeul-umjigineun-saramdeul/saison-1': 'V2',
	'/fr/serie/gambling-school/saison-1': 'V3',
	'/fr/serie/fraggle-rock/saison-4': 'V1',
	'/fr/serie/dead-end-le-parc-du-paranormal/saison-2': 'V2',
	'/fr/serie/gigantosaurus/saison-2': 'V3',
	'/fr/serie/generazione-56k/saison-1': 'V1',
	'/fr/serie/hajime-no-ippo-new-challenger/saison-1': 'V2',
	'/fr/serie/cain/saison-5': 'V3',
	'/fr/serie/chercheurs-dopale/saison-5': 'V1',
	'/fr/serie/dating-unlocked/saison-1': 'V2',
	'/fr/serie/in-the-dark/saison-3': 'V3',
	'/fr/serie/go-vive-a-tu-manera/saison-2': 'V1',
	'/fr/serie/atom/saison-1': 'V2',
	'/fr/serie/australia-zoo-le-defi-des-irwin/saison-2': 'V3',
	'/fr/serie/dating-around/saison-1': 'V1',
	'/fr/serie/3d-kanojo-real-girl/saison-1': 'V2',
	'/fr/serie/30-days-with-ryan-garcia/saison-1': 'V3',
	'/fr/serie/cabanes-perchees/saison-10': 'V1',
	'/fr/serie/cabanes-perchees/saison-2': 'V2',
	'/fr/serie/cabanes-perchees/saison-7': 'V3',
	'/fr/serie/cabanes-perchees/saison-9': 'V1',
	'/fr/serie/dolpung/saison-1': 'V2',
	'/fr/serie/football-parents/saison-1': 'V3',
	'/fr/serie/1994/saison-1': 'V1',
	'/fr/serie/chercheurs-dopale/saison-6': 'V2',
	'/fr/serie/chercheurs-dopale/saison-4': 'V3',
	'/fr/serie/haigakura/saison-1': 'V1',
	'/fr/serie/ghost-adventures/saison-24': 'V2',
	'/fr/serie/court-of-gold/saison-1': 'V3',
	'/fr/serie/alice-nevers-le-juge-est-une-femme/saison-4': 'V1',
	'/fr/serie/casamento-as-cegas-brasil/saison-2': 'V2',
	'/fr/serie/fiasco/saison-1': 'V3',
	'/fr/serie/flame-of-recca/saison-1': 'V1',
	'/fr/serie/army-wives/saison-6': 'V2',
	'/fr/serie/60il-jijeongsaengjonja/saison-1': 'V3',
	'/fr/serie/capitani/saison-1': 'V1',
	'/fr/serie/docteur-la-peluche/saison-2': 'V2',
	'/fr/serie/dragons-the-nine-realms/saison-4': 'V3',
	'/fr/serie/extracurricular/saison-1': 'V1',
	'/fr/serie/fear-thy-neighbor/saison-10': 'V2',
	'/fr/serie/betty-boop/saison-1': 'V3',
	'/fr/serie/babies/saison-1': 'V1',
	'/fr/serie/connexions-dangereuses/saison-6': 'V2',
	'/fr/serie/descendants-generation-mechants/saison-1': 'V3',
	'/fr/serie/disney-les-making-of-the-mandalorian/saison-2': 'V1',
	'/fr/serie/get-organized-with-the-home-edit/saison-1': 'V2',
	'/fr/serie/crimes-of-passion/saison-1': 'V3',
	'/fr/serie/angelo-rules/saison-4': 'V1',
	'/fr/serie/cars-toon-martin-se-la-raconte/saison-1': 'V2',
	'/fr/serie/dragons-rescue-riders-heros-du-ciel/saison-1': 'V3',
	'/fr/serie/commissaire-dupin/saison-1': 'V1',
	'/fr/serie/degrassi-next-class/saison-2': 'V2',
	'/fr/serie/bad-girls-club/saison-16': 'V3',
	'/fr/serie/entrapped-2022/saison-1': 'V1',
	'/fr/serie/hana-yori-dango/saison-1': 'V2',
	'/fr/serie/ghost-adventures/saison-3': 'V3',
	'/fr/serie/demain-je-serai-en-couple/saison-1': 'V1',
	'/fr/serie/famille-daccueil/saison-1': 'V2',
	'/fr/serie/disparu/saison-1': 'V3',
	'/fr/serie/hanabbunin-naepyeon/saison-1': 'V1',
	'/fr/serie/doctor-who-1963/saison-23': 'V2',
	'/fr/serie/cigarette-girl/saison-1': 'V3',
	'/fr/serie/fais-pas-ci-fais-pas-ca/saison-9': 'V1',
	'/fr/serie/half-et-half/saison-1': 'V2',
	'/fr/serie/aguila-roja/saison-5': 'V3',
	'/fr/serie/erika-jayne-bet-it-all-on-blonde/saison-1': 'V1',
	'/fr/serie/blackstone/saison-4': 'V2',
	'/fr/serie/hitoshi-matsumoto-presents-dokiyumentaru/saison-1': 'V3',
	'/fr/serie/benjamin-blumchen/saison-2': 'V1',
	'/fr/serie/bunnytown/saison-1': 'V2',
	'/fr/serie/cake-boss/saison-4': 'V3',
	'/fr/serie/drive-2013/saison-6': 'V1',
	'/fr/serie/a-history-of-christianity/saison-1': 'V2',
	'/fr/serie/gutsy/saison-1': 'V3',
	'/fr/serie/dans-le-cerveau-de-bill-gates/saison-1': 'V1',
	'/fr/serie/fate-grand-carnival/saison-1': 'V2',
	'/fr/serie/crazyhead/saison-1': 'V3',
	'/fr/serie/abby-hatcher/saison-3': 'V1',
	'/fr/serie/alska-mig/saison-2': 'V2',
	'/fr/serie/aj-and-the-queen/saison-1': 'V3',
	'/fr/serie/bebefinn/saison-2': 'V1',
	'/fr/serie/cetait-moi/saison-1': 'V2',
	'/fr/serie/deliver-me-2024/saison-1': 'V3',
	'/fr/serie/demi-lovato-dancing-with-the-devil/saison-1': 'V1',
	'/fr/serie/crime-scene-the-texas-killing-fields/saison-1': 'V2',
	'/fr/serie/homicide-city/saison-1': 'V3',
	'/fr/serie/7-little-johnstons/saison-3': 'V1',
	'/fr/serie/agi-bagi/saison-1': 'V2',
	'/fr/serie/army-wives/saison-5': 'V3',
	'/fr/serie/borg-mom/saison-1': 'V1',
	'/fr/serie/brave-10/saison-1': 'V2',
	'/fr/serie/brothers-conflict/saison-1': 'V3',
	'/fr/serie/claudine/saison-1': 'V1',
	'/fr/serie/conspiracy/saison-1': 'V2',
	'/fr/serie/constructions-hors-limites/saison-10': 'V3',
	'/fr/serie/critter-fixers-country-vets/saison-2': 'V1',
	'/fr/serie/curious-traveler/saison-3': 'V2',
	'/fr/serie/curious-traveler/saison-5': 'V3',
	'/fr/serie/dans-la-tete-dalan-moore/saison-1': 'V1',
	'/fr/serie/dolly-partons-heartstrings/saison-1': 'V2',
	'/fr/serie/dynamo-magicien-de-limpossible/saison-1': 'V3',
	'/fr/serie/food-safari/saison-2': 'V1',
	'/fr/serie/goodbye-to-goodbye/saison-1': 'V2',
	'/fr/serie/historia-de-un-crimen-colosio/saison-1': 'V3',
	'/fr/serie/el-tigre/saison-1': 'V1',
	'/fr/serie/elves/saison-1': 'V2',
	'/fr/serie/hoffman-family-gold/saison-2': 'V3',
	'/fr/serie/bordertown-2016/saison-1': 'V1',
	'/fr/serie/3-x-manon/saison-1': 'V2',
	'/fr/serie/50-nuances-de-grecs/saison-2': 'V3',
	'/fr/serie/akuma-kun/saison-1': 'V1',
	'/fr/serie/anime-gataris/saison-1': 'V2',
	'/fr/serie/ao-no-kanata-no-four-rhythm/saison-1': 'V3',
	'/fr/serie/bijeongsanghoedam/saison-1': 'V1',
	'/fr/serie/btx/saison-1': 'V2',
	'/fr/serie/cake-boss/saison-10': 'V3',
	'/fr/serie/chroniques-dun-dictateur/saison-1': 'V1',
	'/fr/serie/compagnons-insolites/saison-1': 'V2',
	'/fr/serie/damayanti/saison-1': 'V3',
	'/fr/serie/drugs-inc/saison-5': 'V1',
	'/fr/serie/el-kebeer-awi/saison-1': 'V2',
	'/fr/serie/el-soffara/saison-1': 'V3',
	'/fr/serie/general-electric-theater/saison-3': 'V1',
	'/fr/serie/grandart/saison-1': 'V2',
	'/fr/serie/great-parks-of-africa/saison-1': 'V3',
	'/fr/serie/hiiro-no-kakera/saison-2': 'V1',
	'/fr/serie/histoire-s-du-cinema/saison-1': 'V2',
	'/fr/serie/house-arrest/saison-1': 'V3',
};

export default metaDescriptionVariantTitles;
